import _ from 'lodash'

export const AGENT_STATUS_RELEASED = "release"
export const AGENT_STATUS_NEW = "new"
export const AGENT_STATUS_SPOKE = "spoke-to-client"
export const AGENT_STATUS_MET = "met-showing"
export const AGENT_STATUS_OFFER = "offers-made"
export const AGENT_STATUS_CONTRACT = "contract"
export const AGENT_STATUS_CLOSED = "closed"
export const AGENT_STATUS_CONFIRMED_CLOSED = "confirmed-closed"
export const AGENT_STATUS_BANNER_VISIBLE = [AGENT_STATUS_NEW, AGENT_STATUS_SPOKE, AGENT_STATUS_MET]

export const OFFER_STATUS_WAITING = "waiting"
export const OFFER_STATUS_ACCEPTED = "accepted"
export const OFFER_STATUS_REJECTED = "rejected"
export const OFFER_STATUS_NO_NEW_OFFERS = "no-new-offers"
export const DISPUTE_REASON_OTHER = "other"

export const PACKAGE_TYPES = {
  NEW: 'new',
  ADDITIONAL: 'additional',
  REPLACEMENT: 'replacement',
}

export const LEAD_STAGES = [
  {value: "new", label: "New"},
  {value: "no-phone", label: "No Phone"},
  {value: "junk", label: "Junk"},
  {value: "no-contact", label: "No Contact"},
  {value: "saved", label: "Saved"},
  {value: "contact", label: "Contact"},
  {value: "callback", label: "Callback"},
  {value: "assigned", label: "Assigned"},
  {value: "referred", label: "Referred"},
  {value: "lost", label: "Lost"},
  {value: "credit-repair", label: "Credit Repair"},
  {value: "lender-only", label: "Lender Only"},
  {value: "agent-only", label: "Agent Only"},
  {value: "released", label: "Released"},
  {value: "arrived", label: "Arrived"},
  {value: "reactivated", label: "Reactivated"},
  {value: "duplicate", label: "Duplicate"},
  {value: "snoozed", label: "Snoozed"},
]

export const BROKER_LEAD_STAGES = [
  {value:'referred',label:'Referred'},
  {value:'referred-network',label:'Referred (Network)'},
  {value:'working',label:'Working'},
  {value:'working-new',label:'Working (New)'},
  {value:'working-revived',label:'Working (Revived)'},
  {value:'stopped-working',label:'Stopped Working'},
  {value:'stopped-working-failed-screen',label:'Stopped Working (Failed Screen)'},
  {value:'stopped-working-failed-screen-not-eligible',label:'Stopped Working (Failed Screen) - Not Eligible'},
  {value:'stopped-working-failed-screen-not-interested',label:'Stopped Working (Failed Screen) - Not Interested'},
  {value:'stopped-working-failed-screen-bad-data',label:'Stopped Working (Failed Screen) - Bad Data'},
  {value:'stopped-working-failed-screen-do-not-call',label:'Stopped Working (Failed Screen) - Do Not Call'},
  {value:'stopped-working-no-agents',label:'Stopped Working (No Agents Found)'},
  {value:'closed',label:'Closed'},
  {value:'released',label:'Released'},
]

export const PIPELINE_CALL_LOG_SELECTABLE = [
  {value:"called-completed-discussion",label:"Called - Made Contact - Completed Discussion"},
  {value:"called-rescheduled",label:"Called - Made Contact - Rescheduled"},
  {value:"called-call-dropped",label:"Called - Made Contact - Call Dropped"},
  {value:"called-no-answer-no-vm",label:"Called - No Answer - No VM"},
  {value:"called-no-answer-left-vm",label:"Called - No Answer - Left VM"},
  {value:"called-busy",label:"Called - Busy Signal"},
]

export const PIPELINE_CALL_LOG_SELECTABLE_SHORT = [
  {value:"called-completed-discussion",label:"Made Contact - Completed"},
  {value:"called-rescheduled",label:"Made Contact - Rescheduled"},
  {value:"called-call-dropped",label:"Made Contact - Call Dropped"},
  {value:"called-no-answer-no-vm",label:"Called - No Answer - No VM"},
  {value:"called-no-answer-left-vm",label:"Called - No Answer - Left VM"},
  {value:"called-busy",label:"Called - Busy Signal"},
]

export const PIPELINE_NO_CONTACT_CALL_LOG_SELECTABLE = [
  {value: "called-no-answer-no-vm", label:"Called - No Answer - No VM"},
  {value: "called-no-answer-left-vm", label:"Called - No Answer - Left VM"},
  {value: "called-busy", label:"Called - Busy Signal"},
]

export const CALL_LOG_SELECTABLE = [
  {value:"called-busy",label:"Called - Busy Signal"},
  {value:"called-no-answer-no-vm",label:"Called - No Answer - No VM"},
  {value:"called-no-answer-left-vm",label:"Called - No Answer - Left VM"},
  {value:"called-bad-phone",label:"Called - Bad Phone"},
  {value:"called-dispatch-unsuccessful",label:"Called - Dispatch Unsuccessful"},
  {value:"called-consumer-disconnected",label:"Called - Consumer Disconnected"},
  {value:"called-consumer-unavailable",label:"Called - Consumer Unavailable"},
  {value:"spanish",label:"Spanish Speaker"},
]

export const CALL_LOG = CALL_LOG_SELECTABLE.concat([
  {value:"leave-note",label:"Note Only"},
  {value:"not-spanish",label:"Non-Spanish Speaker"},
  {value:"clear-sms",label:"SMS Cleared"},
  {value:"clear-dupe",label:"New Inquiry Cleared"},
  {value:"clear-new-inquiry",label:"New Inquiry Cleared"},
])

export const AGENT_STATUS_TYPE = [
  {value:"no-agent",label:"No Agent"},
  {value:"agent-uncommitted",label:"Has Agent, Uncommitted"},
  {value:"agent-committed",label:"Has Agent, Committed"},
]

export const LEAD_TYPE = [
  {value:"asap",label:"As Soon As Possible"},
  {value:"90-days",label:"<90 days"},
  {value:"3-6mo",label:"3-6 months"},
  {value:"6-9mo",label:"6-9 months"},
  {value:"9-12mo",label:"9-12 months"},
  {value:">1yr",label:">1yr"},
  {value:"not-sure",label:"Not Sure"},
]

export const LEAD_TYPE_TO_NOTE = [
  {value:"asap",label:"as soon as possible"},
  {value:"90-days",label:"in the next 90 days"},
  {value:"3-6mo",label:"in 3-6 months"},
  {value:"6-9mo",label:"in 6-9 months"},
  {value:"9-12mo",label:"in 9-12 months"},
  {value:">1yr",label:"more than a year from now"},
  {value:"not-sure",label:"in an unknown time frame"},
]

export const LEAD_TYPE_TO_NOTE_SPANISH = [
  {value:"asap",label:"lo más pronto posible"},
  {value:"90-days",label:"en los proximos 90 dias"},
  {value:"3-6mo",label:"en 3-6 meses"},
  {value:"6-9mo",label:"en 6-9 meses"},
  {value:"9-12mo",label:"en 9-12 meses"},
  {value:">1yr",label:"en más de uno año"},
  {value:"not-sure",label:"un periodo de tiempo especifico"},
]

export const SHORT_LEAD_TYPE = [
  {value:"asap",label:"ASAP"},
  {value:"90-days",label:"<90 days"},
  {value:"3-6mo",label:"3-6 months"},
  {value:"6-9mo",label:"6-9 months"},
  {value:"9-12mo",label:"9-12 months"},
  {value:">1yr",label:">1yr"},
  {value:"not-sure",label:"Not Sure"},
]

export const INTERNAL_PRICE = [
  {value:"<60",label:"<60k"},
  {value:"60-100",label:"60k - 100k"},
  {value:"100-150",label:"100k - 150k"},
  {value:"150-300",label:"150k - 300k"},
  {value:"300-500",label:"300k - 500k"},
  {value:"500-1M",label:"500k - 1M"},
  {value:"1M+",label:"1M+"},
  {value:"unknown",label:"Unknown"},
]

export const PRICE = [
  {value:"<60",label:"<60k"},
  {value:"<100",label:"60k - 100k"},
  {value:"100-150",label:"100k - 150k"},
  {value:"150-300",label:"150k - 300k"},
  {value:"300-500",label:"300k - 500k"},
  {value:"500-1M",label:"500k - 1M"},
  {value:"1M+",label:"1M+"},
  {value:"unknown",label:"Unknown"},
]

export const SETTLEMENT_PORTAL_PRICE = [
  {value:"<60",label:"< $60k"},
  {value:"<100",label:"$60k - $100k"},
  {value:"100-150",label:"$100k - $150k"},
  {value:"150-300",label:"$150k - $300k"},
  {value:"300-500",label:"$300k - $500k"},
  {value:"500-1M",label:"$500k - $1M"},
  {value:"1M+",label:"$1M+"},
  {value:"unknown",label:"Price Range Unknown"},
]

export const DISPLAY_PRICE = [
  {value:"<60",label:"<60k"},
  {value:"60-100",label:"60k - 100k"},
  {value:"<100",label:"<100k"},
  {value:"100-150",label:"100k - 150k"},
  {value:"150-300",label:"150k - 300k"},
  {value:"300-500",label:"300k - 500k"},
  {value:"500-1M",label:"500k - 1M"},
  {value:"1M+",label:"1M+"},
  {value:"unknown",label:"Unknown"},
]

export const PRICE_CUTOFFS = [
    {min: 1000000, category: "1M+"},
    {min: 500000, max: 1000000, category: "500-1M"},
    {min: 300000, max: 500000, category: "300-500"},
    {min: 150000, max: 300000, category: "150-300"},
    {min: 100000, max: 150000, category: "100-150"},
    {min: 60000, max: 100000, category: "60-100"},
    {max: 60000, category: "<60"},
]

export const CREDIT_SCORE_LEGACY = [
  {value:"<600",label:"<600"},
  {value:"600-700",label:"600-700"},
  {value:"700-800",label:"700-800"},

  {value:"Unknown",label:"Client Doesn’t Know"},
  {value:"<580",label:"<580"},
  {value:"580-619",label:"580-619"},
  {value:"620-650",label:"620-650"},
  {value:"651-699",label:"651-699"},
  {value:"700-800",label:"700-800"},
  {value:">800",label:">800"},

  {value:"poor",label:"Poor"},
  {value:"fair",label:"Fair"},
  {value:"good",label:"Good"},
  {value:"excellent",label:"Excellent"},
]

export const CREDIT_SCORE = [
  {value:"Unknown",label:"Consumer Didn't Answer / Doesn’t Know"},
  {value:"excellent",label:"Excellent"},
  {value:"good",label:"Good"},
  {value:"fair",label:"Fair"},
  {value:"poor",label:"Poor"},
]

export const CREDIT_SCORE_SPANISH = [
  {value:"Unknown",label:"Desconocido"},
  {value:"excellent",label:"Excelente"},
  {value:"good",label:"Bueno"},
  {value:"fair",label:"Adecuado"},
  {value:"poor",label:"Negativo"},
]

export const CREDIT_SCORE_FF_09_18 = [
  {value:"excellent",label:"Excellent"},
  {value:"good",label:"Good"},
  {value:"fair",label:"Fair"},
  {value:"poor",label:"Poor"},
]

export const LOAN_TYPE = [
  {value:"traditional",label:"Traditional"},
  {value:"alternative",label:"Alternative"},
  {value:"manufactured",label:"Manufactured Home"},
]

export const BUYER_TYPE = [
  {value:"buyer-seller",label:"Buyer/Seller"},
  {value:"buyer",label:"Buyer"},
  {value:"seller",label:"Seller"},
  {value:"investor",label:"Investor"},
  {value:"lease-other",label:"Lease / Rent-to-Own"}
]

export const MOTIVATED_LEAD_CLASSIFICATION_OPTIONS = [
  {value:"buyer-seller",label:"Motivated Buyer/Seller"},
  {value:"buyer",label:"Buyer"},
  {value:"seller",label:"Motivated Seller"},
  {value:"investor",label:"Investor"},
  {value:"lease-other",label:"Lease / Rent-to-Own"}
]

export const BUYER_TYPE_TO_NOTE = [
  {value:"buyer-seller",label:"buy and sell"},
  {value:"buyer",label:"buy"},
  {value:"seller",label:"sell"},
  {value:"investor",label:"buy"},
  {value:"lease-other",label:"lease"}
]

export const LOCATION = [
  {value:"in-town",label:"In Town"},
  {value:"out-of-town",label:"Out of Town"},
]

export const GENDER = [
  {value:"no-preference",label:"No Preference"},
  {value:"male",label:"Male"},
  {value:"female",label:"Female"},
]

export const AGENT_GENDER = [
  {value:"male",label:"Male"},
  {value:"female",label:"Female"},
  {value:"no-preference",label:"Prefer not to say"},
]

export const FORM_CHOICE_YES = "yes"
export const FORM_CHOICE_NO = "no"
export const YES_NO = [
  {value: FORM_CHOICE_YES, label: "Yes"},
  {value: FORM_CHOICE_NO, label: "No"},
]

export const LANGUAGE = [
  {value:"no-preference",label:"No Preference"},
  {value:"spanish",label:"Spanish"},
]

export const LANGUAGE_LEGACY = [
  {value:"no-preference",label:"No Preference"},
  {value:"spanish",label:"Spanish"},
  {value:"vietnamese",label:"Vietnamese"},
  {value:"arabic",label:"Arabic"},
  {value:"farsi",label:"Farsi"},
  {value:"hindi",label:"Hindi"},
  {value:"marathi",label:"Marathi"},
  {value:"gujrathi",label:"Gujrathi"},
  {value:"italian",label:"Italian"},
  {value:"mandarin",label:"Mandarin"},
  {value:"taiwanese",label:"Taiwanese"},
]

export const MORTGAGE = [
  {value:"pre-approved-interested",label:"Pre-approved - Wants to speak to LO"},
  {value:"pre-approved-not-interested",label:"Pre-approved - Does not want to speak to LO"},
  {value:"not-pre-approved-interested",label:"Not Pre-approved - Wants to speak to LO"},
  {value:"not-pre-approved-not-interested",label:"Not pre-approved - Does not want to speak to LO"},
  {value:"no-disclosure-interested",label:"Did not disclose - Wants to speak to LO"},
  {value:"no-disclosure-interested",label:"Did not disclose - Does not want to speak to LO"},
]

export const ASSIGNMENTS = [
  {value:"no-accept", label:"Not Interested"},
  {value:"no-accept-price", label:"Not Interested - Price"},
  {value:"no-accept-location", label:"Not Interested - Location"},
  {value:"no-answer", label:"No Contact"},
  {value:"busy", label:"Busy"},
  {value:"accept", label:"Referred"},
]

export const LOAN_ASSIGNMENTS = [
  {value:"no-accept", label:"Not Interested - Other"},
  {value:"no-accept-price", label:"Not Interested - Price"},
  {value:"no-accept-credit", label:"Not Interested - Fair Credit"},
  {value:"no-answer", label:"No Contact"},
  {value:"busy", label:"Busy"},
  {value:"accept", label:"Referred"},
  {value:"consumer-refused", label: "Consumer Refused"}   // Only for autoclaim_enabled LLQO's!
]

export const RESOLUTIONS_CSR = [
  {value:"agent-only",label:"Agent Only"},
  {value:"lender-only",label:"Lender Only"},
  {value:"active",label:"Lender + Agent"},
  {value:"cash-offer",label: "Referred to HomeGo - Cash Offer"},
  {value:"lost-cant-qualify",label:"Lost - No SSN"},
  {value:"lost-is-agent",label:"Lost - Is an Agent"},
  {value:"lost-already-have-agent",label:"Lost - Already Has Agent"},
  {value:"lost-already-purchased",label:"Lost - Already Purchased"},
  {value:"lost-not-buying-now",label:"Lost - Not Buying Now"},
  {value:"lost-not-interested",label:"Lost - Not Interested"},
  {value:"lost-wants-listing-agent",label:"Lost - Wants Listing Agent"},
  {value:"lost-credit-repair-not-avail",label:"Lost - Market Does Not Allow Credit Repair"},
  {value:"lost-do-not-call",label:"Client specifically requested that we stop contacting them/place them on Do Not Call list"},
  {value:"lost-duplicate",label:"Lost - Duplicate"},
  {value:"lost-homecity-duplicate",label:"Lost - HomeCity Duplicate"},
  {value:"lost-escalated-agent",label:"Lost - Escalated Agent"},
  {value:"lost-sent-to-broker",label:"Lost - Sent to Broker"},
  {value:"lost-alliance", label: "Lost - Sent to ARN"},
]

export const RESOLUTIONS_CSR_LEGACY = [
  {value:"agent-only",label:"Agent Only"},
  {value:"lender-only",label:"Lender Only"},
  {value:"active",label:"Lender + Agent"},
  {value:"credit-repair",label:"Credit Repair"},
  {value:"cash-offer",label: "Referred to HomeGo - Cash Offer"},
  {value:"lost-cant-qualify",label:"Lost - No SSN"},
  {value:"lost-is-agent",label:"Lost - Is an Agent"},
  {value:"lost-already-have-agent",label:"Lost - Already Has Agent"},
  {value:"lost-already-purchased",label:"Lost - Already Purchased"},
  {value:"lost-leasing",label:"Lost - Leasing"},
  {value:"lost-not-buying-now",label:"Lost - Not Buying Now"},
  {value:"lost-not-interested",label:"Lost - Not Interested"},
  {value:"lost-wants-listing-agent",label:"Lost - Wants Listing Agent"},
  {value:"lost-credit-repair-not-avail",label:"Lost - Market Does Not Allow Credit Repair"},
  {value:"lost-do-not-call",label:"Client specifically requested that we stop contacting them/place them on Do Not Call list"},
  {value:"lost-duplicate",label:"Lost - Duplicate"},
  {value:"lost-home-value-too-low",label:"Lost - Home Value Too Low"},
  {value:"lost-homecity-duplicate",label:"Lost - HomeCity Duplicate"},
  {value:"lost-no-agents-in-dispatch", label: "Lost - No Agents Populated in Dispatch"},
  {value:"lost-failed-multiple-dispatch",label:"Lost - Failed Multiple Dispatch Attempts"},
  {value:"lost-escalated-agent",label:"Lost - Escalated Agent"},
  {value:"lost-sent-to-broker",label:"Lost - Sent to Broker"},
  {value:"lost-alliance", label: "Lost - Sent to ARN"}
]

export const RESOLUTIONS = [
  {value:"agent-only",label:"Agent Only"},
  {value:"lender-only",label:"Lender Only"},
  {value:"active",label:"Lender + Agent"},
  {value:"credit-repair",label:"Credit Repair"},
  {value:"cash-offer",label: "Referred to HomeGo - Cash Offer"},
  {value:"lost-cant-qualify",label:"Lost - No SSN"},
  {value:"lost-is-agent",label:"Lost - Is an Agent"},
  {value:"lost-sent-to-broker",label:"Lost - Sent to Broker"},
  {value:"lost-already-have-agent",label:"Lost - Already Has Agent"},
  {value:"lost-already-purchased",label:"Lost - Already Purchased"},
  {value:"lost-not-buying-now",label:"Lost - Not Buying Now"},
  {value:"lost-not-interested",label:"Lost - Not Interested"},
  {value:"lost-wants-listing-agent",label:"Lost - Wants Listing Agent"},
  {value:"lost-credit-repair-not-avail",label:"Lost - Market Does Not Allow Credit Repair"},
  {value:"lost-do-not-call",label:"Lost - Do Not Call"},
  {value:"lost-duplicate",label:"Lost - Duplicate"},
  {value:"lost-homecity-duplicate",label:"Lost - HomeCity Duplicate"},
  {value:"lost-no-agents-in-dispatch", label: "Lost - No Agents Populated in Dispatch"},
  {value:"lost-failed-multiple-dispatch",label:"Lost - Failed Multiple Dispatch Attempts"},
  {value:"lost-escalated-agent",label:"Lost - Escalated Agent"},
  {value:"lost-alliance", label: "Lost - Sent to ARN"},
]
export const RESOLUTIONS_INBOUND = [
  {value:"lost-cant-qualify",label:"Lost - No SSN"},
  {value:"lost-is-agent",label:"Lost - Is an Agent"},
  {value:"lost-already-have-agent",label:"Lost - Already Has Agent"},
  {value:"lost-already-purchased",label:"Lost - Already Purchased"},
  {value:"lost-not-buying-now",label:"Lost - Not Buying Now"},
  {value:"lost-not-interested",label:"Lost - Not Interested"},
  {value:"lost-wants-listing-agent",label:"Lost - Wants Listing Agent"},
  {value:"lost-credit-repair-not-avail",label:"Lost - Market Does Not Allow Credit Repair"},
  {value:"lost-do-not-call",label:"Client specifically requested that we stop contacting them/place them on Do Not Call list"},
  {value:"lost-duplicate",label:"Lost - Duplicate"},
  {value:"lost-homecity-duplicate",label:"Lost - HomeCity Duplicate"},
  {value:"lost-no-agents-in-dispatch", label: "Lost - No Agents Populated in Dispatch"},
]

export const LEAD_SOURCE_TYPES = [
  {value: "seller", label: "Seller"}
]

export const LOAN_ASSIGNMENT_STATUS_LEGACY = [
  {value:"pending",label:"New"},
  {value:"actively-working",label:"Actively Pursuing"},
  {value:"app-taken",label:"Application Taken"},
  {value:"pre-approved",label:"Pre-Qualified"},
  {value:"under-contract", label:"Under Contract"},
  {value:"loan-closed",label:"Loan Closed"},
  {value:"long-term-pipeline",label:"Long Term Hold"},
  {value:"lost",label:"No Longer Working"},

  {value:"following-up",label:"Following Up"},
  {value:"following-up-long-term",label:"Following Up - Long Term"},
  {value:"lost-credit-repair",label:"Lost - Send to Credit Repair"},
  {value:"challenge",label:"Challenged"},
  {value:"other",label:"Other"},
  {value:"lost-no-contact-not-interested",label:"No Longer Working"},

  {value:"lost-not-interested",label:"No Longer Working"},
  {value:"lost-not-responsive",label:"No Longer Working"},
  {value:"lost-unable-to-complete",label:"No Longer Working"},
  {value:"lost-loan-declined-withdrawn",label:"No Longer Working"},

  {value:"lost-not-qualified",label:"No Longer Working"},
  {value:"lost-poor-credit",label:"No Longer Working"},
]

export const LOAN_ASSIGNMENT_STATUS = [
  {value:"pending",label:"New"},
  {value:"actively-working",label:"Actively Pursuing"},
  {value:"app-taken",label:"Application Taken"},
  {value:"pre-approved",label:"Pre-Qualified"},
  {value:"under-contract", label:"Under Contract"},
  {value:"loan-closed",label:"Loan Closed"},
  {value:"long-term-pipeline",label:"Long Term Hold"},
  {value:"lost",label:"No Longer Working"},
]

export const LOAN_ASSIGNMENT_LOST_STATUS_LEGACY = [
  {value:"lost-not-responsive",label:"Exceeded Number of Attempts/Not Responsive"},
  {value:"lost-unable-to-complete",label:"Unable to Complete Application"},
  {value:"lost-not-interested",label:"Customer Not Interested"},

  {value:"lost-not-qualified",label:"Not Qualified"},
  {value:"lost-poor-credit",label:"Poor Credit / Send to Credit Repair"},
  {value:"lost-loan-declined-withdrawn",label:"Loan Declined / Withdrawn"},
  {value:"lost-no-contact-not-interested",label:"Client Not Interested / Not Responsive"},

]

export const LOAN_ASSIGNMENT_LOST_STATUS = [
  {value:"lost-not-qualified",label:"Not Qualified"},
  {value:"lost-poor-credit",label:"Poor Credit / Send to Credit Repair"},
  {value:"lost-loan-declined-withdrawn",label:"Loan Declined / Withdrawn"},
  {value:"lost-no-contact-not-interested",label:"Client Not Interested / Not Responsive"},
]

export const LOAN_ASSIGNMENT_STATUS_MODES = {
  "pending": { 'warning': true},
  "following-up": { 'info': true},
  "following-up-long-term": { 'info': true},
  "actively-working": { 'info': true},
  "long-term-pipeline": { 'info': true},
  "app-taken": { 'info': true},
  "pre-approved": { 'success': true},
  "loan-closed": { 'success': true},
  "lost-no-contact-not-interested": { 'danger': true},
  "lost-loan-declined-withdrawn": { 'danger': true},
  "lost-credit-repair": { 'danger': true},
  "lost-not-interested": { 'danger': true},
  "lost-not-responsive": { 'danger': true},
  "lost-unable-to-complete": { 'danger': true},
  "lost-not-qualified": { 'danger': true},
  "lost-poor-credit": { 'danger': true},
  "challenge": { 'danger': true},
  "other": { 'info': true},
}

export const ASSIGNMENT_AGENT_STATUS = [
  {value:"release",label:"Released"},
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Met"},
  {value:"offers-made",label:"Offer"},
  {value:"contract",label:"Contract"},
  {value:"closed",label:"Close"},
  {value:"confirmed-closed",label:"Confirmed Closed"},
  {value:"released-after-closed",label:"Released After Closed"},
]

export const DISPUTE_REASONS_OPTIONS = [
  { value:"already-done", label:"Already Done" },
  { value:"bad-data", label:"Bad Data" },
  { value:"not-worth-it", label:"Not Worth It" },
  { value:DISPUTE_REASON_OTHER, label:"Other" }
]

export const ASSIGNMENT_AGENT_STATUS_LISTING = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"We Spoke"},
  {value:"met-showing",label:"We Met / Listed Home"},
  {value:"offers-made",label:"We Received Offers"},
  {value:"contract",label:"We're Under Contract"},
  {value:"closed",label:"We Closed"},
  {value:"confirmed-closed",label:"Confirmed Closed"},
]

export const ASSIGNMENT_AGENT_STATUS_LEASE = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"We Spoke"},
  {value:"met-showing",label:"We Viewed Properties"},
  {value:"offers-made",label:"Negotiating Lease"},
  {value:"contract",label:"Lease Signed"},
  {value:"closed",label:"Received My Commission"},
  {value:"confirmed-closed",label:"Confirmed Closed"},
]

export const ASSIGNMENT_AGENT_TRANSITION_NEW_STATUS = [
  {value:"met-showing",label:"We Met / Went House Hunting"},
  {value:"offers-made",label:"We Made An Offer"},
  {value:"contract",label:"We Are Under Contract"},
  {value:"closed",label:"We Closed"},
]

export const ASSIGNMENT_AGENT_TRANSITION_NEW_STATUS_LISTING = [
  {value:"met-showing",label:"We Met / Listed Home"},
  {value:"offers-made",label:"We Received Offers"},
  {value:"contract",label:"We Are Under Contract"},
  {value:"closed",label:"We Closed"},
]

export const ASSIGNMENT_AGENT_TRANSITION_NEW_STATUS_LEASE = [
  {value:"met-showing",label:"We Viewed Properties"},
  {value:"offers-made",label:"We Are Negotiating"},
  {value:"contract",label:"We Signed Lease"},
  {value:"closed",label:"Received My Commission"},
]

export const SHORT_ASSIGNMENT_AGENT_STATUS = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Met"},
  {value:"offers-made",label:"Offer"},
  {value:"contract",label:"Contract"},
  {value:"closed",label:"Close"},
  {value:"confirmed-closed",label:"Closed - Paid"},
  {value:"release",label:"Released"}
]

export const SHORT_ASSIGNMENT_AGENT_STATUS_LISTING = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Met / Listed"},
  {value:"offers-made",label:"Received Offers"},
  {value:"contract",label:"Under Contract"},
  {value:"closed",label:"Closed"},
  {value:"confirmed-closed",label:"Closed - Paid"},
  {value:"release",label:"Released"}
]

export const RM_AGENT_STATUS_BTN_LABEL = [
  {value: AGENT_STATUS_SPOKE, label: 'Spoke'},
  {value: AGENT_STATUS_MET, label: 'Met'},
  {value: AGENT_STATUS_OFFER, label: 'Offer'},
  {value: AGENT_STATUS_CONTRACT, label: 'Contract'},
  {value: AGENT_STATUS_CLOSED, label: 'Close'},
]

export const RM_AGENT_LEASE_STATUS_BTN_LABEL = [
  {value: AGENT_STATUS_SPOKE, label: 'Spoke'},
  {value: AGENT_STATUS_MET, label: 'Met'},
  {value: AGENT_STATUS_OFFER, label: 'Applied'},
  {value: AGENT_STATUS_CONTRACT, label: 'Signed'},
  {value: AGENT_STATUS_CLOSED, label: 'Close'},
]

export const SHORT_ASSIGNMENT_AGENT_STATUS_LEASE = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Viewed Properties"},
  {value:"offers-made",label:"Negotiating Lease"},
  {value:"contract",label:"Lease Signed"},
  {value:"closed",label:"Received My Fee"},
  {value:"confirmed-closed",label:"Closed - Paid"},
  {value:"release",label:"Released"}
]

export const PUBLIC_SHORT_ASSIGNMENT_AGENT_STATUS = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Met / House Hunted"},
  {value:"offers-made",label:"Made An Offer"},
  {value:"contract",label:"Under Contract"},
  {value:"closed",label:"Closed"},
  {value:"confirmed-closed",label:"Closed"},
  {value:"release",label:"Released"}
]

export const SHORT_ASSIGNMENT_STATUS = [
  {value:"open",label:"Open"},
  {value:"release",label:"Released"}
]

export const AGENT_STATUS = [
  {value:"active",label:"Up to date"},
  {value:"warning",label:"Warning"},
  {value:"disabled",label:"Paused"},
  {value:"delinquent",label:"Delinquent"},
]

export const BROKER_STATUS = [
  {value:"enabled",label:"Opcity Enabled"},
  {value:"delinquent",label:"Opcity Delinquent"},
  {value:"disabled",label:"Opcity Disabled"},
]

export const BROKER_BLA_STATUS = [
  {value:"enabled",label:"BLA Enabled"},
  {value:"delinquent",label:"BLA Delinquent"},
  {value:"suspended",label:"BLA Suspended"}
]

export const BROKER_PAYMENT_STATUS = [
  {value:"current",label:"Current"},
  {value:"warning-1",label:"Current"},
  {value:"warning-2",label:"Overdue"},
  {value:"delinquent",label:"Delinquent"},
]

export const BROKER_DELINQUENT_MESSAGE = "Your brokerage has overdue payments and your Opcity leads have been paused until payments are received."

export const BROKER_DELINQUENT_MESSAGE_BLA = `Your brokerage has overdue payments and your Opcity leads have been paused until payments are received.\nYou will still receive broker owned leads.`

export const BROKER_TERMS = [
  {value:"standard",label:"Standard ( 35% / 30% )"},
  {value:"partner",label:"Partner ( 22.5% )"},
  {value:"partner-no-upfront",label:"Partner No Upfront ( 20% )"},
  {value:"partner-paid",label:"Partner Paid ( 10% )"},
]

export const CONFIRMED_QUALITY_PLANS = ['partner-no-upfront', 'partner-no-upfront-advantage-pro']

export const NEW_BROKER_TERMS = [
  {value:"10",label:"Non-Confirmed Quality: 10%"},
  {value:"20",label:"Confirmed Quality: 20%"},
]

export const TRANSACTION_SERVICE_FEES = {
  'partner-paid' : '10',
  'partner-no-upfront' : '20',
  'partner-paid-advantage-pro': '10',
  'partner-no-upfront-advantage-pro': '20',
  'standard': null
}

const BROKER_ACCOUNT_TYPE_BLA = [
  {value:"partner-paid",label:"Non-Confirmed Quality"},
  {value:"partner-no-upfront",label:"Confirmed Quality"},
  {value:"partner-paid-advantage-pro",label:"Non-Confirmed Quality - AdvantagePro"},
  {value:"partner-no-upfront-advantage-pro",label:"Confirmed Quality - AdvantagePro"},
]

export const BROKER_ACCOUNT_TYPE_STANDARD = {value:"standard",label:"Standard"}
export const BROKER_ACCOUNT_TYPE_TRANSITION = {value:"partner-transition",label:"Market VIP",}

export const BROKER_ACCOUNT_TYPE = [BROKER_ACCOUNT_TYPE_STANDARD].concat(BROKER_ACCOUNT_TYPE_BLA)

export const BROKER_AGREEMENT_TYPE_BROKER_WORKFLOW = [
  {value:"standard",label:"Standard"},
  {value:"bla",label:"BLA"},
]

export const CUSTOM_BROKER_TERM_LENGTH = [
  {value: '1', label: '1 Month'},
  {value: '3', label: '3 Months'},
  {value: '4', label: '4 Months'},
]

export const BROKER_TERM_LENGTH = [
  {value: '6', label: '6 Months'},
  {value: '12', label: '1 Year'},
  {value: '24', label: '2 Years'},
]

export const BROKER_TERM_LENGTH_END_DATE = [
  {value: '0', label: 'Custom End Date'}
]

export const LOW_LEVEL_RELEASE_REASON = {
  NOT_INTERESTED: "not-interested",
  LOST_CONTACT: "lost-contact",
  DO_NOT_WANT: "do-not-want",
  POOR_CREDIT: "poor-credit",
  ALREADY_WORKING_WITH_AGENT: "already-working-with-agent",
  NOT_FAMILIAR_WITH_AREA: "not-familiar-with-area",
  WANTS_LISTING_AGENT: "wants-listing-agent",
  DONT_OFFER_PRODUCT: "dont-offer-product",
  LISTED_PROPERTY_NOT_AVAILABLE: "listed-property-not-available",
  UNREALISTIC_CLIENT_EXPECTATIONS: "unrealistic-client-expectations",
  NO_TIME_FOR_CLIENT: "no-time-for-client",
  DUPLICATE: "duplicate",
  INAPPROPRIATE_BEHAVIOR: "inappropriate-behavior",
  OTHER: "other",
  OFFENSIVE_HATE_SPEECH: "offensive-hate-speech",
  OFFENSIVE_SEXUALLY_EXPLICIT: "offensive-sexually-explicit",
  OFFENSIVE_VIOLENCE: "offensive-violent-behavior",
  OFFENSIVE_RUDE_LANGUAGE: "offensive-rude-language",
}

export const HIGH_LEVEL_RELEASE_REASON = {
  LOST_CONTACT: "lost-contact",
  DIFFERENT_AGENT: "different-agent",
  NOT_RIGHT_NOW: "not-right-now",
  INAPPROPRIATE_BEHAVIOR: "inappropriate-behavior",
  OTHER_REASON: "other-reason",
}

export const RELEASE_REASONS = [
  {value: LOW_LEVEL_RELEASE_REASON.NOT_INTERESTED, label: "Client not looking right now", highLevel: HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW},
  {value: LOW_LEVEL_RELEASE_REASON.LOST_CONTACT, label: "Client will not respond", highLevel: HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT },
  {value: LOW_LEVEL_RELEASE_REASON.DO_NOT_WANT, label: "Client is not a good fit for me", highLevel: HIGH_LEVEL_RELEASE_REASON.OTHER_REASON},
  {value: LOW_LEVEL_RELEASE_REASON.POOR_CREDIT, label: "Client not pre-qualified/needs help with financing", highLevel: HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW},
  {value: LOW_LEVEL_RELEASE_REASON.ALREADY_WORKING_WITH_AGENT,label: "Client already has an Agent", highLevel: HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT},
  {value: LOW_LEVEL_RELEASE_REASON.NOT_FAMILIAR_WITH_AREA,label: "Client needs an agent outside of my area", highLevel: HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT},
  {value: LOW_LEVEL_RELEASE_REASON.WANTS_LISTING_AGENT, label:  "Client looking for the listing Agent", highLevel: HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT},
  {value: LOW_LEVEL_RELEASE_REASON.DONT_OFFER_PRODUCT, label: "I don't work the type of property the client desires", highLevel: HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT},
  {value: LOW_LEVEL_RELEASE_REASON.LISTED_PROPERTY_NOT_AVAILABLE, label: "Client's desired property is not available", highLevel: HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW},
  {value: LOW_LEVEL_RELEASE_REASON.UNREALISTIC_CLIENT_EXPECTATIONS, label: "Client expectations not inline with market", highLevel: HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW},
  {value: LOW_LEVEL_RELEASE_REASON.NO_TIME_FOR_CLIENT, label: "I don't have time for this client", highLevel: HIGH_LEVEL_RELEASE_REASON.OTHER_REASON},
  {value: LOW_LEVEL_RELEASE_REASON.DUPLICATE, label: "This is a duplicate referral/I accidentally created it", highLevel: HIGH_LEVEL_RELEASE_REASON.OTHER_REASON},
  {value: LOW_LEVEL_RELEASE_REASON.OTHER, label: "My release reason is not listed", highLevel: HIGH_LEVEL_RELEASE_REASON.OTHER_REASON},
  {value: LOW_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR, label: "Offensive behavior", highLevel: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR},
  {value: LOW_LEVEL_RELEASE_REASON.OFFENSIVE_HATE_SPEECH, label: "Offensive: Hate speech", highLevel: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR},
  {value: LOW_LEVEL_RELEASE_REASON.OFFENSIVE_SEXUALLY_EXPLICIT, label: "Offensive: Sexually explicit", highLevel: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR},
  {value: LOW_LEVEL_RELEASE_REASON.OFFENSIVE_VIOLENCE, label: "Offensive: Violent behavior", highLevel: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR},
  {value: LOW_LEVEL_RELEASE_REASON.OFFENSIVE_RUDE_LANGUAGE, label: "Offensive: Rude language", highLevel: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR},
]

export const HIGH_LEVEL_RELEASE_REASON_TO_LABEL = [
  {value: HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT, label: "Cannot get into contact with client"},
  {value: HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT, label: "Client has or needs different agent"},
  {value: HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW, label: "Client can not purchase right now"},
  {value: HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR, label: "Offensive behavior"},
  {value: HIGH_LEVEL_RELEASE_REASON.OTHER_REASON, label: "Other reason"},
]

export const HIGH_LEVEL_RELEASE_REASON_TO_LABEL_MAP = {
  [HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT]: "Cannot get into contact with client",
  [HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT]: "Client has or needs different agent",
  [HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW]: "Client can not purchase right now",
  [HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR]: "Offensive behavior",
  [HIGH_LEVEL_RELEASE_REASON.OTHER_REASON]: "Other reason",
}

export const RELEASE_REASONS_NOTE_TEXT = {
  [LOW_LEVEL_RELEASE_REASON.NOT_INTERESTED]: "Client not looking right now",
  [LOW_LEVEL_RELEASE_REASON.LOST_CONTACT]: "Client will not respond",
  [LOW_LEVEL_RELEASE_REASON.DO_NOT_WANT]: "Client is not a good fit for me",
  [LOW_LEVEL_RELEASE_REASON.POOR_CREDIT]: "Client not pre-qualified/needs help with financing",
  [LOW_LEVEL_RELEASE_REASON.ALREADY_WORKING_WITH_AGENT]: "Client already has an Agent",
  [LOW_LEVEL_RELEASE_REASON.NOT_FAMILIAR_WITH_AREA]: "Client needs an agent outside of my area",
  [LOW_LEVEL_RELEASE_REASON.WANTS_LISTING_AGENT]: "Client looking for the listing Agent",
  [LOW_LEVEL_RELEASE_REASON.DONT_OFFER_PRODUCT]: "I don't work the type of property the client desires",
  [LOW_LEVEL_RELEASE_REASON.LISTED_PROPERTY_NOT_AVAILABLE]: "Client's desired property is not available",
  [LOW_LEVEL_RELEASE_REASON.UNREALISTIC_CLIENT_EXPECTATIONS]: "Client expectations not inline with market",
  [LOW_LEVEL_RELEASE_REASON.NO_TIME_FOR_CLIENT]: "I don't have time for this client",
  [LOW_LEVEL_RELEASE_REASON.DUPLICATE]: "This is a duplicate referral/I accidentally created it",
  [LOW_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR]: "Client is behaving inapproriately",
  [LOW_LEVEL_RELEASE_REASON.OTHER]: "My release reason is not listed",
}

export const OFFENSIVE_REASONS_TEXT = {
  [LOW_LEVEL_RELEASE_REASON.OFFENSIVE_HATE_SPEECH]: "Hate speech",
  [LOW_LEVEL_RELEASE_REASON.OFFENSIVE_SEXUALLY_EXPLICIT]: "Sexually explicit",
  [LOW_LEVEL_RELEASE_REASON.OFFENSIVE_VIOLENCE]: "Violent behavior",
  [LOW_LEVEL_RELEASE_REASON.OFFENSIVE_RUDE_LANGUAGE]: "Rude language",
}

export const RELEASE_REASONS_TITLE = {
  [HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT]: "How many times have you tried to contact the client after your first phone call?",
  [HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT]: "Let us know why it wasn't a good fit:",
  [HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW]: "Could you give us more details?",
  [HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR]: "We're very sorry this happened. We take this report seriously and want to make sure it never happens again.",
  [HIGH_LEVEL_RELEASE_REASON.OTHER_REASON]: "Could you give us more details?",
}

export const RELEASE_REASONS_FOLLOW_UP = {
  [HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR]: context => `Releasing ${context.referralName || 'this referral'} will remove them from your referrals and block them from contacting you through the app. To help us prevent this type of behavior, we’d appreciate if you could tell us what happened.`,
}

export const HIGH_LEVEL_TO_LOW_LEVELS_REASON = {
  [HIGH_LEVEL_RELEASE_REASON.LOST_CONTACT]: [1, 4, 6, 7],
  [HIGH_LEVEL_RELEASE_REASON.DIFFERENT_AGENT]: [
    LOW_LEVEL_RELEASE_REASON.ALREADY_WORKING_WITH_AGENT,
    LOW_LEVEL_RELEASE_REASON.WANTS_LISTING_AGENT,
    LOW_LEVEL_RELEASE_REASON.NOT_FAMILIAR_WITH_AREA,
    LOW_LEVEL_RELEASE_REASON.DONT_OFFER_PRODUCT,
  ],
  [HIGH_LEVEL_RELEASE_REASON.NOT_RIGHT_NOW]: [
    LOW_LEVEL_RELEASE_REASON.POOR_CREDIT,
    LOW_LEVEL_RELEASE_REASON.LISTED_PROPERTY_NOT_AVAILABLE,
    LOW_LEVEL_RELEASE_REASON.UNREALISTIC_CLIENT_EXPECTATIONS,
    LOW_LEVEL_RELEASE_REASON.NOT_INTERESTED,
  ],
  [HIGH_LEVEL_RELEASE_REASON.INAPPROPRIATE_BEHAVIOR]: [
    LOW_LEVEL_RELEASE_REASON.OFFENSIVE_HATE_SPEECH,
    LOW_LEVEL_RELEASE_REASON.OFFENSIVE_SEXUALLY_EXPLICIT,
    LOW_LEVEL_RELEASE_REASON.OFFENSIVE_VIOLENCE,
    LOW_LEVEL_RELEASE_REASON.OFFENSIVE_RUDE_LANGUAGE,
  ],
  [HIGH_LEVEL_RELEASE_REASON.OTHER_REASON]: [
    LOW_LEVEL_RELEASE_REASON.NO_TIME_FOR_CLIENT,
    LOW_LEVEL_RELEASE_REASON.DUPLICATE,
    LOW_LEVEL_RELEASE_REASON.DO_NOT_WANT,
    LOW_LEVEL_RELEASE_REASON.OTHER,
  ],
}

export const TRANSACTION_DOCUMENT_STATUS = [
  {value: "payment-received-before-invoice", label: "Payment Received before Documentation"},
  {value: "closing-stmt-received", label: "All Docs Received"},
  {value: "not-third-party", label: "Need 3rd Party"},
  {value: "missing-commission", label: "Missing Commission Data"},
]


export const CLOSING_STMT_INCOMPLETE_REASON = [
  {value:"missing-commission",label:"Missing Commission Data"},
  {value:"not-third-party",label:"Requires Third-Party Documentation"},
]

export const CLOSING_STMT_INCOMPLETE_REASON_SHORT = [
  {value:"missing-commission",label:"Missing Commission Data"},
  {value:"not-third-party",label:"Requires Third-Party Doc"},
]

export const CLOSING_CHECKLIST = [
  {value:"none",label:"Not Received"},
  {value:"incomplete",label:"Incomplete Payment"},
  {value:"received",label:"Received"},
]

export const PIPELINE_RELEASE_REASONS = RELEASE_REASONS.concat([{value:"manual-dump",label:"Manual Dump"}])

export const ALL_RELEASE_REASONS = PIPELINE_RELEASE_REASONS.concat([{value:"auto-dump",label:"Auto Dump"}])

export const LONG_TERM_HOLD = [
  {value:"1-mo",label:"1 Month"},
  {value:"2-mo",label:"2 Months"},
  {value:"3-mo",label:"3 Months"},
]

export const LEAD_DOWNLOADS = [
  {value:"all",label:"All Leads"},
  {value:"week",label:"Last 7 Days"},
  {value:"month",label:"Last 30 Days"},
  {value:"current-contract",label:"Current Term"},
]

export const INTRODUCTION_DOWNLOADS = [
  {value:"all",label:"All Introductions"},
  {value:"week",label:"Last 7 Days"},
  {value:"month",label:"Last 30 Days"}
]

export const AGENT_DISTANCE = [
  {value:"5",label:"5 miles"},
  {value:"10",label:"10 miles"},
  {value:"15",label:"15 miles"},
  {value:"20",label:"20 miles"},
  {value:"25",label:"25 miles"},
  {value:"30",label:"30 miles"},
  {value:"45",label:"45 miles"},
  {value:"60",label:"60 miles"},
]

export const AGENT_DISTANCE_DENSE = [
  {value:"0.5",label:"1/2 mile"},
  {value:"1",label:"1 mile"},
  {value:"2",label:"2 miles"},
  {value:"3",label:"3 miles"},
].concat(AGENT_DISTANCE)

export const BROKER_CONTACT_TYPE = [
  {value: "transaction_coordinator", label: "Transaction Coordinator"},
  {value: "relocation_manager", label: "Relocation Manager"},
  {value: "accounting", label: "Accounting"},
  {value: "administrative_other", label: "Administrative / Other"},
  {value: "owner", label: "Owner"},
  {value: "broker", label: "Broker"},
  {value: "broker_agent", label: "Broker / Agent"},
  {value: "agent", label: "Agent"},
  {value: "opcity_portal_manager", label: "Opcity Portal Manager"},
]

export const SNOOZE = [
  {value:"1-hour",label:"1 hour"},
  {value:"2-hours",label:"2 hours"},
  {value:"4-hours",label:"4 hours"},
  {value:"8-hours",label:"8 hours"},
  {value:"24-hours",label:"24 hours"},
  {value:"1-week",label:"1 week"},
]

export const DO_NOT_DISTURB = [
  {value:"00:00", label:"12:00 AM"},
  {value:"00:30", label:"12:30 AM"},
  {value:"01:00", label:"1:00 AM"},
  {value:"01:30", label:"1:30 AM"},
  {value:"02:00", label:"2:00 AM"},
  {value:"02:30", label:"2:30 AM"},
  {value:"03:00", label:"3:00 AM"},
  {value:"03:30", label:"3:30 AM"},
  {value:"04:00", label:"4:00 AM"},
  {value:"04:30", label:"4:30 AM"},
  {value:"05:00", label:"5:00 AM"},
  {value:"05:30", label:"5:30 AM"},
  {value:"06:00", label:"6:00 AM"},
  {value:"06:30", label:"6:30 AM"},
  {value:"07:00", label:"7:00 AM"},
  {value:"07:30", label:"7:30 AM"},
  {value:"08:00", label:"8:00 AM"},
  {value:"08:30", label:"8:30 AM"},
  {value:"09:00", label:"9:00 AM"},
  {value:"09:30", label:"9:30 AM"},
  {value:"10:00", label:"10:00 AM"},
  {value:"10:30", label:"10:30 AM"},
  {value:"11:00", label:"11:00 AM"},
  {value:"11:30", label:"11:30 AM"},
  {value:"12:00", label:"12:00 PM"},
  {value:"12:30", label:"12:30 PM"},
  {value:"13:00", label:"1:00 PM"},
  {value:"13:30", label:"1:30 PM"},
  {value:"14:00", label:"2:00 PM"},
  {value:"14:30", label:"2:30 PM"},
  {value:"15:00", label:"3:00 PM"},
  {value:"15:30", label:"3:30 PM"},
  {value:"16:00", label:"4:00 PM"},
  {value:"16:30", label:"4:30 PM"},
  {value:"17:00", label:"5:00 PM"},
  {value:"17:30", label:"5:30 PM"},
  {value:"18:00", label:"6:00 PM"},
  {value:"18:30", label:"6:30 PM"},
  {value:"19:00", label:"7:00 PM"},
  {value:"19:30", label:"7:30 PM"},
  {value:"20:00", label:"8:00 PM"},
  {value:"20:30", label:"8:30 PM"},
  {value:"21:00", label:"9:00 PM"},
  {value:"21:30", label:"9:30 PM"},
  {value:"22:00", label:"10:00 PM"},
  {value:"22:30", label:"10:30 PM"},
  {value:"23:00", label:"11:00 PM"},
  {value:"23:30", label:"11:30 PM"},
]

export const TIMEZONES = [
  {value:"US/Eastern", label:"Eastern"},
  {value:"US/Central", label:"Central"},
  {value:"US/Mountain", label:"Mountain"},
  {value:"US/Pacific", label:"Pacific"},
]

export const LENDER_BILLING_PERIOD = [
  {value:"biweekly",label:"Biweekly"},
  {value:"monthly",label:"Monthly"},
]

export const DOWNPAYMENT_CATEGORY = [
  {value:"0-3.5",label:"0 - <3.5%"},
  {value:"3.5-10",label:"3.5% - 10%"},
  {value:"10-20",label:"10% - 20%"},
  {value:"20-up",label:"20%+"},
  {value:"unknown",label:"Client Doesn’t Know"},
]

export const EMPLOYMENT_CATEGORY_FF_09_18 = [
  {value:"single-employer-paycheck",label:"Employed"},
  {value:"self-employed-taxes",label:"Self-employed"},
  {value:"other-source-of-income",label:"Other Source Of Income"},
]

export const EMPLOYMENT_CATEGORY_LEGACY_FF_05_18 = [
  {value:"single-employer-paycheck",label:"Employed"},
  {value:"self-employed-taxes",label:"Self-employed"},
  {value:"single-employer",label:"Employed"},
  {value:"multiple-consistent",label:"Multiple consistent employment, at least a year"},
  {value:"self-employed",label:"Self Employed"},
  {value:"not-qualified",label:"Not Qualified"},
  {value:"social-security-pension",label:"Disability / Social Security / Pension"},
  {value:"other-source-of-income",label:"Other Source Of Income"},
  {value:"unknown",label:"Client Doesn’t Know"},
]

export const EMPLOYMENT_CATEGORY_LEGACY = [
  {value:"single-employer-paycheck",label:"Single employer, at least one paystub"},
  {value:"self-employed-taxes",label:"Self-employed, 2 years of tax statements"},
  {value:"single-employer",label:"Single employer, at least a year"},
  {value:"multiple-consistent",label:"Multiple consistent employment, at least a year"},
  {value:"self-employed",label:"Self Employed: at least 2 years of income"},
  {value:"not-qualified",label:"Not Qualified"},
  {value:"social-security-pension",label:"Disability / Social Security / Pension"},
  {value:"other-source-of-income",label:"Other Source Of Income"},
  {value:"unknown",label:"Client Doesn’t Know"},
]

export const MOTIVATION_CATEGORY = [
  {value:"first-time-home-buyer",label:"First-time Home Buyer"},
  {value:"purchased-before",label:"Has Purchased Before"},
  {value:"investment",label:"Investment"},
  {value:"relocation",label:"Relocation (another city)"},
  {value:"selling",label:"Seller"},
  {value:"vacation-home",label:"Vacation Home / Multiple Homes"},
  {value:"leasing",label:"Lease / Rent-to-Own"},
]

export const PROPERTY_TYPE = [
  {value:"no-preference",label:"Any Residential",disabled:true},
  {value:"land",label:"Land"},
  {value:"manufactured",label:"Mobile / Manufactured"},
]

export const PROPERTY_TYPE_SCRIPTING = [
  {value:"no-preference",label:"single-family homes, condos, or townhomes",disabled:true},
  {value:"land",label:"land"},
  {value:"manufactured",label:"mobile or manufactured homes"},
]

export const PROPERTY_TYPE_SCRIPTING_SPANISH = [
  {value:"no-preference",label:"una casa unifamiliar, condominio/apartamento, o townhome",disabled:true},
  {value:"land",label:"comprar terreno"},
  {value:"manufactured",label:"una casa mobile o casa manufacturada"},
]

export const INTERNAL_PROPERTY_TYPE = [
  {value:"no-preference",label:"Any Residential"},
  {value:"land",label:"Land"},
  {value:"manufactured",label:"Mobile / Manufactured"},
]

export const FINANCING_INTEREST = [
  {value:"speak-to-lender", label:"Consumer wants to speak to a lender"},
  {value:"no-lender", label:"No Lender (consumer refused / no lender in market / not qualified)"},
  {value:"not-applicable", label:"Financing not applicable"},
]

export const FINANCING = [
  {value:"financing",label:"Financing"},
  {value:"cash",label:"Cash Buy"}
]

export const FINANCING_CATEGORY_SELECT = [
  {value:"financing-pre-approval",label:"Not Prequalified"},
  {value:"already-pre-qualified",label:"Prequalified"},
  {value:"cash",label:"Cash"},
  {value:"owner-finance",label:"Owner Finance"},
]

// Includes values from FINANCING_CATEGORY_SELECT and legacy values for display only
export const FINANCING_CATEGORY_DISPLAY_VALUES = [
  ...FINANCING_CATEGORY_SELECT,
  {value:"not-applicable",label:"Financing Not Applicable"},
  {value:"financing",label:"Financing"},
  {value:"financing-second-quote",label:"Financing - Second Quote"},
  {value:"financing-no-lender",label:"Financing - Refused Lender"},
  {value:"financing-need-lender",label:"Financing - Needs Lender / Additional Quote"},
]

export const FINANCING_CATEGORY = [
  {value:"financing-pre-approval",label:"Financing - Pre-Qualification"},
  {value:"financing-second-quote",label:"Financing - Second Quote"},
  {value:"cash",label:"Cash + Proof of Funding"}
]

export const FINANCING_CATEGORY_TO_NOTE_AGENT = [
  {value:"financing",label:"not pre-qualified"},
  {value:"financing-pre-approval",label:"not pre-qualified"},
  {value:"already-pre-qualified",label:"pre-qualified"},
  {value:"financing-second-quote",label:"pre-qualified"},
  {value:"financing-no-lender",label:"[SHOULD NOT APPEAR, PLEASE REPORT THIS TO YOUR MANAGER]"},
  {value:"financing-need-lender",label:"not pre-qualified"},
  {value:"cash",label:"paying cash"},
  {value:"not-applicable",label:"[SHOULD NOT APPEAR, PLEASE REPORT THIS TO YOUR MANAGER]"},
  {value:"owner-finance",label:"looking for owner financing"}
]

// doesn't show the difference between pre-approval and second quote
export const FINANCING_CATEGORY_SIMPLIFIED = [
  {value:"financing-pre-approval",label:"Financing"},
  {value:"financing-second-quote",label:"Financing"},
  ...FINANCING_CATEGORY_DISPLAY_VALUES.filter((curr) =>
    ['financing-pre-approval', 'financing-second-quote'].indexOf(curr.value) === -1
  )
]

export const AGENT_CAREER_LENGTH = [
  {value:"<6mo",label:"Less than 6 months"},
  {value:"6mo-1yr",label:"6 mos - 1 year"},
  {value:"1-2yrs",label:"1 - 2 years"},
  {value:">2yr",label:"Over 2 years"},
]

export const TRANSACTION_VOLUME_6_MONTHS = [
  {value:"<$1M",label:"LESS THAN $1M"},
  {value:"$1M",label:"$1M - $1.4M"},
  {value:"$1.5M",label:"$1.5M - $1.9M"},
  {value:">=$2M",label:"$2M OR MORE"},
]

export const TRANSACTION_VOLUME_12_MONTHS = [
  {value:"<$1M",label:"Less than $1M"},
  {value:"$1M",label:"$1M - $1.4M"},
  {value:"$1.5M",label:"$1.5M - $1.9M"},
  {value:">=$2M",label:"$2M or more"},
]

export const TRANSACTION_COUNT_12_MONTHS = [
  {value:"0-1",label:"0 - 1"},
  {value:"2-4",label:"2 - 4"},
  {value:"5-6",label:"5 - 6"},
  {value:">=7",label:"7 or more"},
]

export const SPANISH_OR_NOT = [
  {value:"no",label:"NO"},
  {value:"yes",label:"YES"},
]

export const LEASE_OR_NOT = [
  {value:"yes",label:"I WORK WITH LEASE CLIENTS"},
  {value:"no",label:"I DO NOT WORK WITH LEASE CLIENTS"},
]

export const INVESTOR_OR_NOT = [
  {value:"yes",label:"I WORK WITH INVESTORS"},
  {value:"no",label:"I DO NOT WORK WITH INVESTORS"},
]

export const ONBOARD_STATUS = [
  {value:"failed-criteria",label:"Failed Questionnaire"},
  {value:"failed-criteria-resolved",label:"Failed Questionnaire - Resolved"},
  {value:"email-verify-sent",label:"Email Verify Sent"},
  {value:"email-verified",label:"Email Verified"},
  {value:"submitted",label:"Completed"},
  {value:"flagged",label:"Flagged"},
  {value:"converted-auto",label:"Agent Added - Auto"},
  {value:"converted-manual",label:"Agent Added - Manual"},
]

export const ONBOARD_FLAG_REASON = [
  {value:"existing-failed-criteria",label:"Failed Criteria"},
  {value:"existing-agent-phone",label:"Existing Agent Phone"},
  {value:"existing-agent-email",label:"Existing Agent Email"},
  {value:"existing-agent-license",label:"Existing Agent License"},
  {value:"already-converted",label:"Already Converted"},
]

export const ONBOARD_SIGNUP_MISSING_EMAIL_NAME = "Email or name is missing, please try again!"

export const FAILED_CRITERIA_REASON = [
  {value:"transactions",label:"Transaction Volume / Count"},
  {value:"client-touches",label:"Client Touches"},
  {value:"price-range",label:"Willing Price Ranges"},
  {value:"partner",label:"Can Partner"},
]

export const TRANSACTION_TYPE = [
  {value:"buy",label:"Buying"},
  {value:"list",label:"Listing"},
  {value:"lease",label:"Leasing"},
]

export const CLIENT_TOUCHES = [
  {value:"1",label:"Just once"},
  {value:"2-3",label:"2-3 times, then I give up"},
  {value:">3",label:"4 or more times"},
]

export const CLIENT_TOUCHES_EMG = [
  {value:"1",label:"Just once"},
  {value:"2-3",label:"2-3 times"},
  {value:">3",label:"4 or more times"},
]

export const AGENT_WILLING_PRICE_RANGE = [
  {value:"300k+",label:"Only above $300k"},
  {value:"150k+",label:"Only above $150k"},
  {value:"100k+",label:"Only above $100k"},
  {value:"all",label:"All price ranges"},
]

export const VALIDATION_REP_TASK_TYPE = [
  {value:"need-agent",label:"Needs Agent"},
  {value:"need-lender",label:"Needs Lender"},
]

export const NEEDS_LENDER_TASK_TYPES = [
  'need-lender'
]

export const NEEDS_AGENT_TASK_TYPES = [
  'need-agent'
]

export const CHALLENGE_STATUS = [
  {value:"approve",label:"Approved"},
  {value:"decline",label:"Declined"},
  {value:"pending",label:"Pending"},
]

export const CHALLENGE_NEXT = [
  {value:"lender-challenge",label:"Follow-up with client"},
  {value:"lender-challenge-alternative",label:"Send to an alternative lender"},
  {value:"lender-challenge-credit-repair",label:"Send to credit repair"},
]

export const UNIVERSAL_EXPORT_TIMEFRAME_WEEK = 'week'
export const UNIVERSAL_EXPORT_TIMEFRAME_MONTH = 'month'
export const UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME = 'all'

export const UNIVERSAL_EXPORT_LEAD_COUNT_LIMIT = 2000
export const UNIVERSAL_EXPORT_LEAD_TIME_LIMIT = 20000

export const LEAD_SOURCE_EXPORT_TIMEFRAME = [
  {value:"week",label:"7 Days"},
  {value: UNIVERSAL_EXPORT_TIMEFRAME_MONTH, label:"30 Days"},
  {value:"year",label:"1 year"},
  {value:"this-month",label:"This Month"},
  {value:"this-year",label:"This Year"},
  {value: UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME, label:"All Time"},
]

export const REFERRAL_EXPORT_TIMEFRAME = [
  {value: UNIVERSAL_EXPORT_TIMEFRAME_MONTH, label:"30 Days"},
  {value:"this-month",label:"This Month"},
  {value:"last-month",label:"Last Month"},
  {value:"this-year",label:"This Year"},
  {value:"last-year",label:"Last Year"},
  {value: UNIVERSAL_EXPORT_TIMEFRAME_ALL_TIME, label:"All Time"}
]

export const LEAD_TYPE_OPTIONS = [
  { value: "platinum", label: "Platinum Leads" },
  { value: "promotional", label: "Promotional Leads" },
  { value: "client-rewards", label: "Client Rewards Leads" },
  { value: "traditional", label: "Traditional Leads" },
  { value: "all", label: "All Leads" },
]

export const QUALITY_CONCERN = [
  {value:"note-quality", label:"Poor note quality"},
  {value:"sms-quality", label:"Poor SMS quality"},
  {value:"no-voicemail", label:"Didn't leave voicemail"},
  {value:"rules-of-engagement", label:"Not following rules of engagement"},
  {value:"false-spanish", label:"Falsely marked as Spanish speaker"},
]

export const VOICEMAIL_TYPES = [
  {value:"default-1", label:"VM 1"},
  {value:"default-2", label:"VM 2"},
  {value:"released", label:"Released"},
  {value:"mortgage-1", label:"Mortgage 1"},
  {value:"mortgage-2", label:"Mortgage 2"},
  {value:"partner-default-1", label:"Partner 1"},
  {value:"partner-default-2", label:"Partner 2"},
  {value:"partner-released", label:"Partner Released"},
  {value:"default-1-es", label:"VM 1 Español"},
  {value:"default-2-es", label:"VM 2 Español"},
  {value:"released-es", label:"Released Español"},
  {value:"mortgage-1-es", label:"Mortgage 1 Español"},
  {value:"mortgage-2-es", label:"Mortgage 2 Español"},
  {value:"partner-default-1-es", label:"Partner 1 Español"},
  {value:"partner-default-2-es", label:"Partner 2 Español"},
  {value:"partner-released-es", label:"Partner Released Español"},
  {value:"realtor-default-1", label:"Realtor 1"},
  {value:"realtor-default-2", label:"Realtor 2"},
  {value:"realtor-released", label:"Realtor Released"},
  {value:"realtor-default-1-es", label:"Realtor 1 Español"},
  {value:"realtor-default-2-es", label:"Realtor 2 Español"},
  {value:"realtor-released-es", label:"Realtor Released Español"},
]

export const AGENT_OFFER_STATUS_SELLING_INITIAL = [
  {value:"waiting", label:"Waiting on response"},
  {value:"accepted", label:"Offer was accepted"},
  {value:"rejected", label:"Offer was rejected"},
  {value:"no-new-offers", label:"No new offers"},
]

export const AGENT_OFFER_STATUS_SELLING_INITIAL_SHORT = [
  {value:"waiting", label:"Waiting on response"},
  {value:"accepted", label:"Accepted"},
  {value:"rejected", label:"Rejected"},
  {value:"no-new-offers", label:"No new offers"},
]

export const AGENT_OFFER_STATUS_LISTING_INITIAL = [
  {value:"waiting", label:"Deciding on response"},
  {value:"accepted", label:"Accepted offer"},
  {value:"rejected", label:"Rejected / countered offer"},
  {value:"no-new-offers", label:"No new offers"},
]

export const AGENT_OFFER_STATUS_LISTING_INITIAL_SHORT = [
  {value:"waiting", label:"Deciding on response"},
  {value:"accepted", label:"Accepted"},
  {value:"rejected", label:"Offer was rejected"},
  {value:"no-new-offers", label:"No new offers"},
]

export const AGENT_OFFER_STATUS_SUBSEQUENT = [
  {value:"no-new-offers", label:"No offers currently outstanding"},
]

export const NOTIFICATION_MODES = [
  {value:"sms", label:"SMS / Text Message"},
  {value:"mobile", label:"Mobile Push Notification"},
]

export const AGENT_OFFER_STATUS_LISTING = AGENT_OFFER_STATUS_LISTING_INITIAL.concat(AGENT_OFFER_STATUS_SUBSEQUENT)
export const AGENT_OFFER_STATUS_SELLING = AGENT_OFFER_STATUS_SELLING_INITIAL.concat(AGENT_OFFER_STATUS_SUBSEQUENT)

export const AGENT_CONTRACT_STATUS_UNDER_CONTRACT = "under-contract"
export const AGENT_CONTRACT_STATUS_CONTRACT_AMENDED = "contract-amended"
export const AGENT_CONTRACT_STATUS_CONTRACT_BROKEN = "contract-broken"

export const AGENT_CONTRACT_STATUS = [
  {value: AGENT_CONTRACT_STATUS_UNDER_CONTRACT, label:"Still under contract"},
  {value: AGENT_CONTRACT_STATUS_CONTRACT_AMENDED, label:"Contract amended"},
  {value: AGENT_CONTRACT_STATUS_CONTRACT_BROKEN, label:"Contract broken"},
]

export const AGENT_CONTRACT_STATUS_LEASE = [
  {value: AGENT_CONTRACT_STATUS_UNDER_CONTRACT, label:"Still waiting on my fee"},
  {value: AGENT_CONTRACT_STATUS_CONTRACT_AMENDED, label:"Lease amended"},
  {value: AGENT_CONTRACT_STATUS_CONTRACT_BROKEN, label:"Lease broken"},
]

export const NETWORK_LEAD_OPT_OUT_REASON = [
  {value:"auto-assign", label:"Auto-Assign Lender"},
  {value:"lost-refused-addtl-quote", label:"Opt Out - Refused Additional Quote"},
  {value:"lost-selling-only", label:"Opt Out - Selling Only"},
  {value:"lost-land", label:"Opt Out - Land Only"},
]

export const ALL_TIME_STATS = [
  {order:0, value:"top-activities-payperiod", label:"Most Activities in a Pay Period"},
  {order:1, value:"top-activities-day", label:"Most Activities in a Day"},
  {order:2, value:"top-agents-payperiod", label:"Most Agent Activities in a Pay Period"},
  {order:3, value:"top-agents-day", label:"Most Agent Activities in a Day"},
  {order:4, value:"top-loans-payperiod", label: "Most Total Lender in a Pay Period"},
  {order:5, value:"top-loans-day", label: "Most Total Lender in a Day"},
  {order:6, value:"top-lenders-payperiod", label:"Most Live Lender in a Pay Period"},
  {order:7, value:"top-lenders-day", label:"Most Live Lender in a Day"},
  {order:8, value:"top-network-leads-payperiod", label: "Most Warm Lender in a Pay Period"},
  {order:9, value:"top-network-leads-day", label: "Most Warm Lender in a Day"},
  {order:10, value:"top-credit-repair-payperiod", label:"Most CR Activities in a Pay Period"},
  {order:11, value:"top-credit-repair-day", label:"Most CR Activities in a Day"},
  {order:12, value:"top-dials-payperiod", label:"Most Dials in a Pay Period"},
  {order:13, value:"top-dials-day", label:"Most Dials in a Day"},
  {order:0, value:"top-activities-per-rep-payperiod", label:"Most Team Activities / Rep in a Pay Period"},
  {order:1, value:"top-dials-per-rep-payperiod", label:"Most Team Dials / Rep in a Pay Period"},
  {order:2, value:"top-loans-per-rep-payperiod", label:"Most Team Total Lender / Rep in a Pay Period"},
]

export const SETTLEMENT_ASSIGNMENT_CLIENT_STATUS = [
  {value:"new",label:"New"},
  {value:"spoke-to-client",label:"Spoke"},
  {value:"met-showing",label:"Met"},
  {value:"offers-made",label:"Offer"},
  {value:"contract",label:"Contract"},
  {value:"closed",label:"Close"},
  {value:"confirmed-closed",label:"Close"},
  {value:"release",label:"Released"}
]

export const SETTLEMENT_ASSIGNMENT_CLIENT_STATUS_MODES = {
  "new": { 'warning': true},
  "spoke-to-client": { 'success': true},
  "met-showing": { 'success': true},
  "offers-made": { 'success': true},
  "contract": { 'success': true},
  "closed": { 'success': true},
  "confirmed-closed": { 'success': true},
  "release": { 'default': true},
}

export const LEGACY_SETTLEMENT_OFFICER_AGENT_STATUS = [
  {value:"no-contact", label:"No Contact"},
  {value:"contacted", label:"Contacted"},
  {value:"scheduled-meeting", label:"Scheduled Meeting"},
  {value:"meeting-held", label:"Meeting Held"},
  {value:"commitment", label:"Commitment"},
  {value:"hold", label:"Hold / Long-Term Pipeline"},
  {value:"lost-not-interested", label:"Lost / Not Interested"},
  {value:"lost-in-house", label:"Lost / In-House Brokerage"},
]

export const SETTLEMENT_OFFICER_AGENT_STATUS = [
  {value:"no-contact", label:"New"},
  {value:"contacted", label:"Contacted"},
  {value:"scheduled-meeting", label:"Set Meeting"},
  {value:"meeting-held", label:"Met"},
  {value:"commitment", label:"Commitment"},
  {value:"hold", label:"Long-Term Hold"},
  {value:"lost-not-interested", label:"Lost/Not Interested"},
  {value:"lost-in-house", label:"Lost/Closing-In-House"},
]

export const SETTLEMENT_OFFICER_AGENT_STATUS_MODES = {
  "no-contact": { 'warning': true},
  "contacted": { 'success': true},
  "scheduled-meeting": { 'success': true},
  "meeting-held": { 'success': true},
  "hold": { 'default': true},
  "commitment": { 'success': true},
  "lost-not-interested": { 'danger': true},
  "lost-in-house": { 'danger': true},
}

export const LEGACY_SETTLEMENT_OFFICER_AGENT_STATUS_MODES = {
  "no-contact": { 'warning': true},
  "contacted": { 'info': true},
  "scheduled-meeting": { 'info': true},
  "meeting-held": { 'info': true},
  "hold": { 'info': true},
  "commitment": { 'success': true},
  "lost-not-interested": { 'danger': true},
  "lost-in-house": { 'danger': true},
}

export const SETTLEMENT_OFFICER_AGENT_VALUE = [
  {value:"low", label:"Low"},
  {value:"medium", label:"Medium"},
  {value:"high", label:"High"},
]

export const SETTLEMENT_OFFICER_AGENT_VALUE_MODES = {
  "low": { 'danger': true},
  "medium": { 'warning': true},
  "high": { 'success': true},
}

export const SETTLEMENT_OFFICER_AGENT_VALUE_ICONS = {
  "low": 'fa-caret-down',
  "medium": 'fa-minus',
  "high": 'fa-caret-up',
}

export const MARKET_CAPACITY = [
  {value:"red_hot", label:"Red Hot"},
  {value:"red", label:"Red"},
  {value:"yellow", label:"Yellow"},
  {value:"orange", label:"Orange"},
  {value:"green", label:"Green"},
  {value:"grey", label:"Grey"},
]


export const INFRACTION_LEVEL = [
  {value:"level-1", label:"Moderate"},
  {value:"level-2", label:"Severe"},
  {value:"level-3", label:"Critical"},
]


export const COACHING_STATUS = {
  ALL: {label: "View all", value: 0},
  COACHED: {label: "Coached", value: 1},
  NEEDS_COACHING: {label: "Needs Coaching", value: 2},
  PUBLISHED: {label: "Published", value: 3},
}


export const INFRACTION_LEVEL_LEGACY = [
  {value:"level-0", label:"Level 0", code: "L0"},
  {value:"level-1", label:"Level 1", code: "L1"},
  {value:"level-2", label:"Level 2", code: "L2"},
  {value:"level-3", label:"Level 3", code: "L3"},
]

export const ALL_INFRACTION_LEVEL = INFRACTION_LEVEL.concat(INFRACTION_LEVEL_LEGACY)


export const INFRACTION_CATEGORY = [
  {value: "l1-texting-protocol", label: "Texting Protocol"},
  {value: "l1-callback-protocol", label: "Callback and Voicemail Protocol"},
  {value: "l1-lead-management", label: "Lead Management Guidelines"},
  {value: "l1-losing-leads", label: "Losing Leads"},
  {value: "l1-adequate-data", label: "Failure to Collect/Communicate Accurate Data"},
  {value: "l2-mortgage-quality-standards", label: "Mortgage Quality Standards"},
  {value: "l2-false-representation", label: "False Representation of Opcity"},
  {value: "l2-cold-transfer", label: "Cold Transfer"},
  {value: "l2-ff-manipulation", label: "Manipulation of System"},
  {value: "l2-profanity", label: "Profanity"},
  {value: "l2-silence", label: "Silence"},
  {value: "l3-serious-misconduct", label: "Serious Misconduct"},
  {value: "l3-legally-prohibited", label: "Legally Prohibited"},
  {value: "l3-legal-disclaimers", label: "Legal Disclaimers"},
]

export const INFRACTION_CATEGORY_LEGACY = [
  {value: "l0-coaching-only", label: "L0 - Coaching Only"},
  {value: "l1-adequate-data", label: "L1 - Failure to collect adequate data for dispatch"},
  {value: "l1-advice", label: "L1 - Giving Advice"},
  {value: "l1-agent-no-accept", label: "L1 - Bridging the client into the call before agent has agreed to speak"},
  {value: "l1-bad-referral", label: "L1 - Referring a client that has no intention of working with agent/lender"},
  {value: "l1-misrepresent-client", label: "L1 - Misinforming agent or misrepresenting client"},
  {value: "l1-mortgage-quality", label: "L1 - Mortgage Quality"},
  {value: "l1-off-script", label: "L1 - Not covering mandatory sections of script"},
  {value: "l1-roe-lead-mgmt", label: "L1 - ROE and Lead Management"},
  {value: "l1-skip-winner", label: "L1 - Failure to call agent or lender who wins dispatch"},
  {value: "l2-cold-transfer", label: "L2 - Cold transfer"},
  {value: "l2-csr-direct", label: "L2 - Texting the client instructions to call CSR directly"},
  {value: "l2-false-representation", label: "L2 - False representation of Opcity"},
  {value: "l2-ff-manipulation", label: "L2 - FocusFire manipulation"},
  {value: "l2-legally-prohibited", label: "L2 - Legally prohibited rules that require licensing"},
  {value: "l3-objective-advice", label: "L3 - Objective advice"},
  {value: "l3-opcity-manipulation", label: "L3 - Manipulating Opcity systems"},
  {value: "l3-subjective-advice", label: "L3 - Subjective advice"},
  {value: "l3-unprofessional-phone-behavior", label: "L3 - Unprofessional phone behavior"},
]

export const ALL_INFRACTION_CATEGORY = INFRACTION_CATEGORY.concat(INFRACTION_CATEGORY_LEGACY)


export const INFRACTION_DISPLAY = [
  {value: "l0-coaching-only", description: "Coaching Only"},
  {value: "l1-adequate-data", description: "Failure to collect adequate data for dispatch"},
  {value: "l1-advice", description: "Giving Advice"},
  {value: "l1-agent-no-accept", description: "Bridging the client into the call before agent has agreed to speak"},
  {value: "l1-bad-referral", description: "Referring a client that has no intention of working with agent/lender"},
  {value: "l1-callback-protocol", description: "Callback and Voicemail Protocol"},
  {value: "l1-lead-management", description: "Lead Management Guidelines"},
  {value: "l1-losing-leads", description: "Losing Leads"},
  {value: "l1-misrepresent-client", description: "Misinforming agent or misrepresenting client"},
  {value: "l1-mortgage-quality", description: "Mortgage Quality"},
  {value: "l1-off-script", description: "Not covering mandatory sections of script"},
  {value: "l1-roe-lead-mgmt", description: "ROE and Lead Management"},
  {value: "l1-skip-winner", description: "Failure to call agent or lender who wins dispatch"},
  {value: "l1-texting-protocol", description: "Texting Protocol"},
  {value: "l2-cold-transfer", description: "Cold transfer"},
  {value: "l2-csr-direct", description: "Texting the client instructions to call CSR directly"},
  {value: "l2-false-representation", description: "False Representation of Opcity"},
  {value: "l2-ff-manipulation", description: "Manipulation of System"},
  {value: "l2-legally-prohibited", description: "Legally prohibited rules that require licensing"},
  {value: "l2-profanity", description: "Profanity"},
  {value: "l2-silence", description: "Silence"},
  {value: "l2-mortgage-quality-standards", description: "Mortgage Quality Standards"},
  {value: "l3-legal-disclaimers", description: "Legal Disclaimers"},
  {value: "l3-legally-prohibited", description: "Legally Prohibited"},
  {value: "l3-objective-advice", description: "Objective advice"},
  {value: "l3-opcity-manipulation", description: "Manipulating Opcity systems"},
  {value: "l3-serious-misconduct", description: "Serious Misconduct"},
  {value: "l3-subjective-advice", description: "Subjective advice"},
  {value: "l3-unprofessional-phone-behavior", description: "Unprofessional phone behavior"},
]

export const US_STATES = [
  {value: "AL", label: "Alabama"},
  {value: "AK", label: "Alaska"},
  {value: "AZ", label: "Arizona"},
  {value: "AR", label: "Arkansas"},
  {value: "CA", label: "California"},
  {value: "CO", label: "Colorado"},
  {value: "CT", label: "Connecticut"},
  {value: "DE", label: "Delaware"},
  {value: "DC", label: "District Of Columbia"},
  {value: "FL", label: "Florida"},
  {value: "GA", label: "Georgia"},
  {value: "GU", label: "Guam"},
  {value: "HI", label: "Hawaii"},
  {value: "ID", label: "Idaho"},
  {value: "IL", label: "Illinois"},
  {value: "IN", label: "Indiana"},
  {value: "IA", label: "Iowa"},
  {value: "KS", label: "Kansas"},
  {value: "KY", label: "Kentucky"},
  {value: "LA", label: "Louisiana"},
  {value: "ME", label: "Maine"},
  {value: "MD", label: "Maryland"},
  {value: "MA", label: "Massachusetts"},
  {value: "MI", label: "Michigan"},
  {value: "MN", label: "Minnesota"},
  {value: "MS", label: "Mississippi"},
  {value: "MO", label: "Missouri"},
  {value: "MT", label: "Montana"},
  {value: "NE", label: "Nebraska"},
  {value: "NV", label: "Nevada"},
  {value: "NH", label: "New Hampshire"},
  {value: "NJ", label: "New Jersey"},
  {value: "NM", label: "New Mexico"},
  {value: "NY", label: "New York"},
  {value: "NC", label: "North Carolina"},
  {value: "ND", label: "North Dakota"},
  {value: "OH", label: "Ohio"},
  {value: "OK", label: "Oklahoma"},
  {value: "OR", label: "Oregon"},
  {value: "PA", label: "Pennsylvania"},
  {value: "PR", label: "Puerto Rico"},
  {value: "RI", label: "Rhode Island"},
  {value: "SC", label: "South Carolina"},
  {value: "SD", label: "South Dakota"},
  {value: "TN", label: "Tennessee"},
  {value: "TX", label: "Texas"},
  {value: "UT", label: "Utah"},
  {value: "VT", label: "Vermont"},
  {value: "VA", label: "Virginia"},
  {value: "WA", label: "Washington"},
  {value: "WV", label: "West Virginia"},
  {value: "WI", label: "Wisconsin"},
  {value: "WY", label: "Wyoming"}
]

export const BROKER_CONTACT_TYPES = [
  {value: "owner", label: "Owner"},
  {value: "broker", label: "Broker"},
  {value: "broker_agent", label: "Broker / Agent"},
  {value: "agent", label: "Agent"},
  {value: "opcity_portal_manager", label: "Opcity Portal Manager"},
  {value: "operations_relocation_manager", label: "Relocation Manager"},
  {value: "coordinator", label: "Transaction Coordinator"},
  {value: "accountant", label: "Accounting"},
  {value: "other", label: "Administrative / Other"}
]

export const BROKER_CONTACT_TYPES_DISPLAY = {
  owner: 'Owner',
  broker: 'Broker',
  broker_agent: 'Broker / Agent',
  agent: 'Agent',
  opcity_portal_manager: 'Opcity Portal Manager',
  operations_relocation_manager: 'Relocation Manager',
  coordinator: 'Transaction Coordinator',
  accountant: 'Accounting',
  other: 'Administrative / Other'
}

export const AGENT_EXPERIENCE_LEVELS = [
  {value: "emerging", label: "Emerging Agent"},
  {value: "experienced", label: "Experienced Agent"},
]

export const AGENT_EXPERIENCE_LEVELS_SHORT = [
  {value: "emerging", label: "Emerging"},
  {value: "experienced", label: "Experienced"},
]

export const PAYROLL_TYPES = [
  {value: "bd_broker", label: "BD - Broker"},
  {value: "bd_lender", label: "BD - Lender"},
  {value: "csr", label: "CSR"},
  {value: "other", label: "Pipeline, CSRM, CSRO"},
  {value: "released_leads", label: "Released Leads"},
]

export const PAYROLL_PAY_PERIODS = [
  {value: "January 1-15", label: "January 1-15"},
  {value: "January 16-31", label: "January 16-31"},
  {value: "February 1-15", label: "February 1-15"},
  {value: "February 16-28", label: "February 16-28"},
  {value: "February 16-29", label: "February 16-29"},
  {value: "March 1-15", label: "March 1-15"},
  {value: "March 16-31", label: "March 16-31"},
  {value: "April 1-15", label: "April 1-15"},
  {value: "April 16-30", label: "April 16-30"},
  {value: "May 1-15", label: "May 1-15"},
  {value: "May 16-31", label: "May 16-31"},
  {value: "June 1-15", label: "June 1-15"},
  {value: "June 16-30", label: "June 16-30"},
  {value: "July 1-15", label: "July 1-15"},
  {value: "July 16-31", label: "July 16-31"},
  {value: "August 1-15", label: "August 1-15"},
  {value: "August 16-31", label: "August 16-31"},
  {value: "September 1-15", label: "September 1-15"},
  {value: "September 16-30", label: "September 16-30"},
  {value: "October 1-15", label: "October 1-15"},
  {value: "October 16-31", label: "October 16-31"},
  {value: "November 1-15", label: "November 1-15"},
  {value: "November 16-30", label: "November 16-30"},
  {value: "December 1-15", label: "December 1-15"},
  {value: "December 16-31", label: "December 16-31"}
]

export const AGENT_FEATURE_FLAGS = [
  {value: "bulk_add_zip_filter", label: "Bulk Zip Filter"},
  {value: "score_and_metrics_enabled_at", label: "Agent Score and Metrics"},
]

export const DISABLED_AGENTS_FILTERS = [
    {value: 'all-agents', label: 'All Disabled Agents'},
    {value: 'auto-dump-enabled', label: 'Auto-Dump Enabled'},
    {value: 'auto-dump-disabled', label: 'Auto-Dump Disabled'},
]

export const SUPER_TASK_TYPE_TO_DISPLAY = {
  'coaching': 'Coaching',
  'additional-transaction-suspected': 'More Transactions Expected',
  'likely-close': 'Likely Close',
  'suspicious': 'Suspicious Activity',
  'agent-action-required': 'Agent Action Required'
}

export const RESEARCH_UNREPORTED_CLOSE = 'research-unreported-close'

export const PIPELINE_ICONS = {
  'additional-transaction-suspected': 'fa fa-search-plus',
  'likely-close': 'fa fa-bullseye',
  'suspicious': 'fa fa-user-secret',
  'agent-action-required': 'fa fa-exclamation-triangle'
}

export const PIPELINE_TIERS = {
  'tier-1': 'Tier 1',
  'tier-2': 'Tier 2'
}

export const PIPELINE_TRANSACTION_TYPE = {
  'buy': 'Buying',
  'list': 'Listing',
  'lease': 'Lease'
}

export const PIPELINE_RDC_TRANSACTION_TYPE = {
  'buy': 'Buying',
  'sell': 'Listing'
}

export const TASK_ACTIVITY_WEIGHT_CUTOFF = 0.8
export const TASK_ACTIVITY_WEIGHT_CUTOFF_COACHING = 0.2

export const AGENT_SMS_TEMPLATE_LABELS = {
  'closed': 'Closed',
  'under contract': 'Under ctrct',
  'accounting': 'Accounting',
  'support': 'Support',
  'no contact 1': 'No contact 1',
  'no contact 2': 'No contact 2',
  'no contact 3': 'No contact 3',
  'paused': 'Paused',
  'delinquent': 'Delinquent',
  'onboarded': 'Onboarded',
  'call complete': 'Call complete',
  'rescheduled': 'Rescheduled',
}

export const MOBILE_FEATURE_INBOX = 'agent_inbox'
export const MOBILE_FEATURE_VOIP = 'agent_inbox_voip'
export const MOBILE_FEATURE_SUGGEST_TOUR = 'suggest_tour'
export const MOBILE_FEATURE_OPEN_URL = 'open_url'
export const L2C_FLOW = 'lead-to-close-flow'
export const DOCUMENT_EMAIL_FLOW = 'document-email-flow'

export const UNKNOWN_MARKET_ID = 1005
export const ATL_MARKET_ID = 1015
export const CSR_TEAM_TYPE_ID = 1
export const TRAINING_TEAM_IDS = [7, 524]
export const BD_BROKER_MANAGER_ID = 155
export const BD_LENDER_MANAGER_ID = 89
export const APPLE = 'apple'
export const ANDROID = 'android'
export const APPLE_APP_URL = 'https://itunes.apple.com/us/app/opcity/id1232078017'
export const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.opcity'
export const AUTO_SMS = 'Auto-SMS'
export const RQ_STATUS_STARTED = 'started'
export const RQ_STATUS_FINISHED = 'finished'
export const RQ_STATUS_FAILED = 'failed'
export const BROKER_REMOVED_REASON_DEPARTING = 'departing-brokerage'
export const BROKER_REMOVED_REASON_OPT_OUT = 'opt-out'
export const BROKER_REMOVED_REASON_MOVED = 'moved-brokerage'
export const GOOGLE_API_KEY = 'AIzaSyDW4QvCxIG8fq7n_DsT677zWLX7MovJXXI'
export const LEAD_SOURCE_HIGH_CUT_OFF = 8
export const LEAD_SOURCE_LOW_CUT_OFF = 5
export const MIN_LEAD_COUNT = 50

export const PIPELINE_TASK_MOVE_ON_STAGES = [
  'in-progress',
  'complete'
]

export const QUICKBOOKS_URL = 'https://c18.qbo.intuit.com/app/'

export const SETTLEMENT_OPT_OUT_REASONS = [
  {value:'rates', label:'did not have as good of rates'},
  {value:'investigations', label:'was not as thorough in their investigations'},
  {value:'unresponsive', label:'was not responsive/communicative enough'},
  {value:'distance-too-far', label:'was too far away from the client'},
  {value:'market', label:'did not service the market the client closed in'},
  {value:'other-side', label:'The closing Settlement Company was chosen by the'}
]

export const LOAN_OPT_OUT_REASONS = [
  {value:'slow-approval', label:'did not have as quick a pre-approval process'},
  {value:'rates', label:'did not have as good of rates'},
  {value:'loan-type', label:'did not offer the loan type required by my client'},
  {value:'unresponsive', label:'was not responsive/communicative enough'},
  {value:'guidance', label:'did not provide the necessary guidance'},
  {value:'distance-too-far', label:'was too far away from the client who wanted to meet in person'},
  {value:'market', label:'did not service the market that the client closed in'},
]

export const RESOLUTION_ACTIVITY_LABELS = {
  'resolve-through-agent-contact': 'Resolve through agent contact',
  'resolve-through-lender-contact': 'Resolve through lender contact',
  'resolve-through-client-contact': 'Resolve through client contact',
  'resolve-through-public-records': 'Resolve through public records',
  'keywords-suspicious-resolve-through-agent-contact': 'Keyword(s) suspicious. Resolve through agent contact',
  'likely-close-transaction-review': 'Resolve through transaction review',
  'onboarding-conversation-disposition': 'Offer onboarding to agent',
}

export const RESOLUTION_ACTIVITY_ACTION_TYPES = {
  MARK_COMPLETE: 'mark_resolution_activity_complete',
  MARK_INCOMPLETE: 'mark_resolution_activity_incomplete',
  MARK_REQUIRED: 'mark_resolution_activity_required',
  MARK_NOT_REQUIRED: 'mark_resolution_activity_not_required'
}

export const BROKER_INVITE_CONTACT_TYPES = {
  BROKER_CONTACT: 'broker-contact',
  BROKER_USER: 'broker-user',
  AGENT: 'agent'
}

export const SECRET_FEATURE_FLAGS = [
  'show_waive_fees_setting',
  'set_waive_fees_setting',
  'engineering_team',
  'is_advanced_csr',
  'super_masquerade',
  'hotkeys',
  'sound_enabled',
]

export const BROKER_AGREEMENT_HISTORY_STAGE = {
  'created': 'Created',
  'initial_send': 'Sent',
  'resend': 'Resent',
  'signed': 'Signed',
  'initial_new_agreement_send': 'Sent',
  'new_agreement_resend': 'Resent',
  'viewed': 'Viewed',
}

export const BROKER_AGREEMENT_STAGE_TO_STATUS_PILL = {
  'grey': ['created', 'initial_send', 'resent', 'initial_new_agreement_send', 'new_agreement_resend', 'viewed'],
  'green': ['signed'],
}

export const BROKER_AGREEMENT_TYPE = {
  'standard': 'Standard',
  'bla': 'BLA'
}

export const AGENT_RECOMMEND_ANSWERS = [
  {value:"highly-likely",label:"Highly Likely"},
  {value:"somewhat-likely",label:"Somewhat Likely"},
  {value:"not-likely",label:"Not Likely"},
  {value:"neutral",label:"Neutral / No Memory of Agent"},
]
export const AGENT_FIT_ANSWERS = [
  {value: "not-looking", label: "I'm not looking right now"},
  {value: "agent-no-contact", label: "Haven't heard from agent"},
  {value: "financing-problems", label: "I'm having financing challenges"},
  {value: "working-with-other-agent", label: "I'm working with another agent"},
  {value: "agent-unfamiliar-with-area", label: "Agent not familiar with my area"},
  {value: "agent-not-helpful", label: "Agent not helpful with my home search"},
  {value: "house-unavailable", label: "The house I wanted isn't available"},
  {value: "other", label: "Other"},
]

export const APP_ENV_PROD = 'PROD'
export const TRAINING_APP_ENVS = ['TRAINING']

export const LEAD_DO_NOT_CALL_LIST_STATUSES = [
  {value: "do-not-call", label: "Do Not Call"},
  {value: "call", label: "Call"},
]

export const LEAD_DO_NOT_CALL_STATUS = 'do-not-call'
export const LEAD_CALL_STATUS = 'call'

export const QUOTA_PACKAGE_STATUS_PAUSED = "paused"
export const QUOTA_PACKAGE_STATUS_ACTIVE = "active"

export const QUOTA_PACKAGE_STATUSES = [
  {value: QUOTA_PACKAGE_STATUS_PAUSED, label: "Paused"},
  {value: "draft", label: "Draft"},
  {value: "reserved", label: "Reserved"},
  {value: "reserved-pending", label: "Reserving"},
  {value: "signed", label: "Pending Payment"},
  {value: QUOTA_PACKAGE_STATUS_ACTIVE, label: "Active"},
  {value: "pending", label: "Pending Launch"},
  {value: "canceled", label: "Canceled"},
  {value: "canceled-pending", label: "Canceled Pending"},
  {value: "scheduled-canceled-pending", label: "Cancel on Final Billing Date"},
]

export const CHANGEABLE_QUOTA_PACKAGE_STATUSES = [
  QUOTA_PACKAGE_STATUS_PAUSED, "active",
]

export const SELECTABLE_QUOTA_PACKAGE_STATUSES = [
  {value: QUOTA_PACKAGE_STATUS_ACTIVE, label: "Active"},
]

export const SELECTABLE_QUOTA_PACKAGE_STATUS_PAUSED = [
  {value: QUOTA_PACKAGE_STATUS_PAUSED, label: "Pause"}
]

export const SELECTABLE_QUOTA_PACKAGE_STATUSES_WITH_CANCELLATION = [
    {value: "canceled-pending", label: "Canceled"}
]

export const SELECTABLE_QUOTA_PACKAGE_STATUSES_WITH_SCHEDULED_CANCELLATION = [
  {value: "scheduled-canceled-pending", label: "Cancel on Final Billing Date", is_scheduled_cancellation: true},
]

export const QUOTA_PACKAGE_STATUS_MAP = {
  QUOTA_PACKAGE_STATUS_PAUSED: 'Paused',
  'draft': 'Draft',
  'reserved': 'Reserved',
  'signed': 'Pending',
  QUOTA_PACKAGE_STATUS_ACTIVE: 'Active',
  'pending': 'Pending Launch',
  'canceled': 'Canceled',
  'canceled-pending': 'Canceled'
}

export const QUOTA_PURCHASE_AGREEMENT_STAGE = {
  'created': 'Created',
  'sending': 'Sending',
  'sent': 'Sent',
  'signed': 'Signed',
  'paid': 'Charged',
  'failed-payment': 'Failed Payment',
  // The following are package statuses that are pseudo-stages
  // for purposes of rendering the table.
  'activated': 'Activated',
  'canceled': 'Canceled',
  'suspended': 'Suspended'
}

export const QUOTA_PURCHASE_TERM_LENGTHS_LENDER = [
  {value: "one-month", label: "1 Month"},
  {value: "two-months", label: "2 Months"},
  {value: "three-months", label: "3 Months"},
  {value: "four-months", label: "4 Months"},
  {value: "five-months", label: "5 Months"},
  {value: "six-months", label: "6 Months"},
  {value: "one-year", label: "1 Year"},
]

export const QUOTA_PURCHASE_TERM_LENGTHS_LENDER_NEW_ACCOUNTS = [
  {value: "three-months", label: "3 Months"},
  {value: "six-months", label: "6 Months"},
  {value: "one-year", label: "1 Year"},
]

export const QUOTA_PURCHASE_TERM_LENGTHS_TITLE = [
  {value: "one-month", label: "1 Month"},
  {value: "two-months", label: "2 Months"},
  {value: "three-months", label: "3 Months"},
  {value: "four-months", label: "4 Months"},
  {value: "six-months", label: "6 Months"},
  {value: "one-year", label: "1 Year"},
]

export const QUOTA_PURCHASE_TERM_LENGTHS_TITLE_NEW_ACCOUNTS = [
  {value: "four-months", label: "4 Months"},
  {value: "six-months", label: "6 Months"},
  {value: "one-year", label: "1 Year"},
]

export const LenderOptions = {
  OTHER_LENDER: 0,
  PREFERRED_LENDER: 1,
  CASH_PURCHASE: 2,
}

export const PREFERRED_LENDER_OPTIONS = [
  {value: LenderOptions.PREFERRED_LENDER, label: "Preferred Lender"},
  {value: LenderOptions.OTHER_LENDER, label: "Other Lender"},
  {value: LenderOptions.CASH_PURCHASE, label: "Cash Purchase"},
]

export const OTHER_LENDER_OPTIONS = [
  {value: LenderOptions.OTHER_LENDER, label: "Other Lender"},
  {value: LenderOptions.CASH_PURCHASE, label: "Cash Purchase"},
]

export const BLA_LEAD_SOURCES = [
  {value: 'Realtor.com', label: 'Realtor.com'},
  {value: 'Zillow', label: 'Zillow'},
  {value: 'Trulia', label: 'Trulia'},
  {value: 'Homes.com', label: 'Homes.com'},
  {value: 'Commissions Inc.', label: 'Commissions Inc.'},
  {value: 'Social Media', label: 'Social Media'},
  {value: 'PPC', label: 'PPC'},
  {value: 'SEO', label: 'SEO'},
  {value: 'Zap/Lead Router', label: 'Zap/Lead Router'},
  {value: 'Boomtown', label: 'Boomtown'},
  {value: 'Brokerage Website', label: 'Brokerage Website'},
  {value: 'Inbound Phone', label: 'Inbound Phone'},
  {value: 'SMS', label: 'SMS'}
]

export const LEAD_OWNER_COMMISSION_STATUS = {
  UNPAID: 'unpaid',
  PAID: 'paid',
}

export const LEAD_OWNER_COMMISSION_STATUS_DESCRIPTION = {
  'unpaid': 'Unpaid',
  'paid': 'PAID',
}

export const LEAD_OWNER_TYPE = {
  BROKER: 'broker',
  REV_SHARE: 'rev-share',
  OPCITY: 'opcity',
}

export const LEAD_OWNER_LABEL = {
  'broker': 'Lead Owner',
  'rev-share': 'Vendor',
}

export const INQUIRY_TYPES = [
  {value: 'email', label: "Inbound Email"},
  {value: 'api', label: "API"},
  {value: 'phone', label: "Inbound Call"},
  {value: 'sms', label: "Inbound SMS"},
]

export const PAYMENT_SOURCE_TYPE = {
  CARD: 'card',
  BANK_ACCOUNT: 'bank-account',
}

export const PAYMENT_SOURCE_TYPES = [
  {value: 'card', label: 'Credit Card'},
  {value: 'bank-account', label: 'Bank Account'},
]

export const STRIPE_CHARGE_STATUS = {
  SUCCEEDED: 'succeeded',
  FAILED: 'failed',
  PENDING: 'pending',
}

export const STRIPE_MAX_LINE_ITEMS = 20

export const STRIPE_CHARGE_STATUS_OPTIONS = [
  {value: 'succeeded', label: 'Succeeded'},
  {value: 'failed', label: 'Failed'},
  {value: 'pending', label: 'Pending'},
]

export const CANCELLATION_SCHEDULE_STATUS_OPTIONS = [
  {value: 'scheduled-this-period', label: 'Scheduled to Cancel This Period'},
  {value: 'scheduled', label: 'Scheduled to Cancel at Contract End'},
  {value: 'previous-cancellation', label: 'Canceled Previously'},
  {value: 'not-scheduled', label: 'Not Scheduled'}
]

export const MAX_BUDGET_CATEGORY_OPTIONS = [
  {value: 'max-budget', label: 'Max Budget'},
  {value: 'unknown-budget', label: 'Unknown Budget'},
]

export const HAS_MILITARY_CONNECTION_OPTIONS = [
  {value: true, label: 'Yes'},
  {value: false, label: 'No'},
]

export const QUOTA_PRODUCT = {
  LOAN: 'loan',
  SETTLEMENT: 'settlement'
}

export const PRIVACY_POLICY_URL = 'https://www.opcity.com/privacy-policy/'
export const QUALIA_PRIVACY_POLICY_URL = 'https://www.qualia.com/privacy-policy/'
export const QUALIA_TERMS_URL = 'https://www.qualia.com/terms/'

export const NUMBER_WORDS = [
  '', 'one', 'two', 'three', 'four',
  'five', 'six', 'seven', 'eight', 'nine',
  'ten', 'eleven', 'twelve', 'thirteen', 'fourteen',
  'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'
]

export const NEW_CALL_GRADE_FORM = [
  {
    sectionTitle: 'CONSUMER PROFILE',
    sectionType: 'pass-fail',
    questions: [
      {key: 'proper_introduction', label: 'Proper Introduction', type: 'question', subtext: ''},
      {key: 'accurate_purchase_information', label: 'Accurate Purchase Information', type: 'subsection', questions: [
        {key: 'motivation_classification', label: 'Motivation/Classification', subtext: ''},
        {key: 'agent_status', label: 'Agent Status', subtext: ''},
        {key: 'budget', label: 'Budget', subtext: ''},
        {key: 'timeframe', label: 'Timeframe', subtext: ''},
        {key: 'property_type', label: 'Property Type', subtext: ''},
      ]},
      {key: 'accurate_financing_information', label: 'Accurate Financing Information', type: 'subsection', questions: [
        {key: 'financing_status', label: 'Financing Status', subtext: ''},
        {key: 'mortgage_quality_standards', label: 'Mortgage Quality Standards', subtext: ''},
      ]},
      {key: 'confirmed_name_email_zip', label: 'Confirmed name, email, and zip code', type: 'subsection', questions: [
        {key: 'name', label: 'Name', subtext: ''},
        {key: 'email', label: 'Email', subtext: ''},
        {key: 'zipcode', label: 'Zip Code', subtext: ''},
      ]},
      {key: 'connected_consumer_to_the_right_client', label: 'Connected consumer to right client', type: 'question', subtext: ''},
    ]
  },
  {
    sectionTitle: 'LEGAL',
    sectionType: 'pass-fail',
    questions: [
      {key: 'disclaimers_read_verbatim', label: 'Disclaimers Read Verbatim', type: 'subsection', questions: [
        {key: 'consumer_recording_disclaimer', label: 'Intro Disclaimers', subtext: '', relevantCallAnalysisFindingTypes: ['no-consumer-recording-disclaimer', 'fail-speech-consumer-recording-disclaimer']},
        {key: 'client_recording_disclaimer', label: 'Client Recording Disclaimer', subtext: '', relevantCallAnalysisFindingTypes: ['no-client-recording-disclaimer']},
        {key: 'agent_or_lender_transfer_disclaimer', label: 'Agent or Lender Transfer Disclaimer', subtext: '', relevantCallAnalysisFindingTypes: ['no-agent-transfer-disclaimer']},
      ]},
      {key: 'advice', label: 'Advice', type: 'question', subtext: ''},
      {key: 'asking_for_listing_agent_rebuttal_read_verbatim', label: '"Asking for Listing Agent" Rebuttal Read Verbatim', type: 'question', subtext: ''},
    ]
  },
  {
    sectionTitle: 'CONSUMER EXPERIENCE',
    sectionType: 'likert',
    questions: [
      {key: 'courtesy', label: 'Courtesy', type: 'question', subtext: 'Respect, Calm Demeanor, Flexibility, Professional Triangle, Empathy'},
      {key: 'active-listening', label: 'Active Listening', type: 'question', subtext: 'Listening Cues, Clarification'},
      {key: 'communication-skills', label: 'Communication Skills', type: 'question', subtext: 'Tonality, Pace, Rapport'},
      {key: 'transparency', label: 'Transparency', type: 'question', subtext: 'Product Knowledge, Honesty'},
    ]
  }
]

export const GRADE_CALL_SECTIONS = {
  'INTRODUCTION': [
    {key: 'professional_behavior_while_ringing', label: 'Professional behavior while ringing', subtext: ''},
    {key: 'opcity_realtor_partner', label: 'Opcity/Realtor.com/Partner Brokerage', subtext: ''},
    {key: 'coordinator_consumer_recording_disclaimer', label: 'Coordinator/Consumer Recording Disclaimer', subtext: ''},
    {key: 'put_you_in_touch_with_buyers_agent', label: '"Put you in touch with a buyers agent"', subtext: 'Asking for the Listing Agent Rebuttal'},
    {key: 'homestead_or_investment', label: 'Homestead OR Investment', subtext: ''},
    {key: 'first_time_buyer_or_previous_buyer_if_homestead', label: 'First Time Buyer OR Previous Buyer (If Homestead)', subtext: ''},
    {key: 'seller_if_investor_or_previous_buyer', label: 'Seller (If Investor or Previous Buyer)', subtext: ''},
  ],
  'PRELIMINARY QUESTIONS': [
    {key: 'agent_status', label: 'Agent Status', subtext: ''},
    {key: 'timeframe', label: 'Timeframe', subtext: ''},
    {key: 'property_type', label: 'Property Type', subtext: ''},
    {key: 'budget', label: 'Budget', subtext: ''},
    {key: 'financing_or_cash', label: 'Financing OR Cash', subtext: ''},
    {key: 'dispatch_form_updated_with_accurate_info', label: 'Dispatch form updated with accurate information', subtext: ''},
    {key: 'all_selling_questions_asked_and_answered_if_seller', label: 'All selling questions asked and answered (If Seller)', subtext: ''},
  ],
  'REBUTTALS (IF NECESSARY)': [
    {key: 'has_agent_rebuttal', label: 'Has an Agent', subtext: ''},
    {key: 'timeframe_rebuttal', label: 'Timeframe Rebuttal', subtext: ''},
    {key: 'price_range_rebuttal', label: 'Price Range Rebuttal', subtext: ''},
    {key: 'asking_for_listing_agent_rebuttal', label: 'Asking for Listing Agent', subtext: ''},
    {key: 'leasing_rebuttal', label: 'Leasing Rebuttal', subtext: ''},
    {key: 'questions_about_inquiry_address_rebuttal', label: 'Questions about Inquiry Address', subtext: ''},
    {key: 'owner_finance_rebuttal', label: 'Owner Finance', subtext: ''},
    {key: 'who_are_you_why_are_you_calling_rebuttal', label: '"Who are you?"/"Why are you calling?"', subtext: ''},
    {key: 'i_just_want_to_see_the_home_have_agent_meet_me_rebuttal', label: '"I just want to see the home"/"Have agent meet me"', subtext: ''},
    {key: 'agent_lender_support_questions_rebuttal', label: 'Agent/Lender Support Questions', subtext: ''},
  ],
  'LENDER/MQQS': [
    {key: 'csr_has_asked_for_lo_transfer', label: 'CSR has asked for (live) LO transfer', subtext: ''},
    {key: 'csr_used_applicable_rebuttals', label: 'CSR used applicable rebuttals (if necessary)', subtext: ''},
    {key: 'consumer_verbally_states_they_want_to_speak_with_lo', label: 'Consumer verbally states they want to speak with LO', subtext: ''},
    {key: 'mqqs_asked_answered_meet_all_standards', label: 'MQQ\'s asked,answered and meet all standards', subtext: ''},
    {key: 'dispatch_form_updated_with_accurate_credit_and_employment_info', label: 'Dispatch form updated with accurate credit and employment info', subtext: ''},
    {key: 'lender_disclaimer', label: 'Lender [in our network] disclaimer', subtext: ''},
  ],
  'LENDER TRANSFER': [
    {key: 'lender_recording_disclaimer', label: 'Lender recording disclaimer', subtext: ''},
    {key: 'csr_placed_client_on_hold_and_brings_lo_up_to_speed_with_accurate_info_regarding_the_consumer', label: 'CSR placed client on hold and brings LO up to speed with accurate info regarding the consumer', subtext: ''},
    {key: 'lo_agrees_to_work_with_consumer', label: 'LO agrees to work with the consumer', subtext: ''},
    {key: 'csr_merges_call_confirms_client_is_still_on_line_and_makes_intro', label: 'CSR merges call,confirms client is still on the line and makes intro', subtext: ''},
    {key: 'csr_reconfirms_all_accurate_info_and_exits_line_with_consumer_and_lo_talking', label: 'CSR reconfirms all acurrate info and exits line with consumer and LO talking', subtext: ''},
  ],
  'AGENT TRANSFER': [
    {key: 'agents_disclaimer', label: 'Agents [in our network] disclaimer', subtext: ''},
    {key: 'agent_recording_disclaimer', label: 'Agent recording disclaimer', subtext: ''},
    {key: 'confirm_agent_will_work_with_consumer', label: 'Confirm agent will work with consumer', subtext: ''},
    {key: 'confirm_consumer_is_still_on_the_line', label: 'Confirm consumer is still on the line', subtext: ''},
    {key: 'reconfirm_financing_cash_timeframe_agent_status_meeting_time_price_range', label: 'Reconfirm Financing/Cash, Timeframe, Agent Status, Meeting Time, Price Range', subtext: ''},
    {key: 'confirm_and_update_name_email_before_transfer', label: 'Confirm and update Name/Email before transfer', subtext: ''},
    {key: 'csr_has_hard_date_time', label: 'CSR has hard Date/Time (If Network Lead)', subtext: ''},
  ],
  'MISCELLANEOUS': [
    {key: 'connected_consumer_to_the_right_client', label: 'Connected consumer to the right client', subtext: 'CSR followed process'},
    {key: 'tonality_and_pace_throughout_the_call', label: 'Tonality and pace throughout the call', subtext: ''},
    {key: 'call_length_and_call_control', label: 'Call length and call control', subtext: ''},
    {key: 'notes_on_lead_and_also_to_lender_agent', label: 'Notes on lead and also to Lender/Agent', subtext: 'Should include accurate and differing information than the dispatch'},
    {key: 'advice', label: 'Advice', subtext: ''},
    {key: 'did_the_csr_utilize_yonyx', label: 'Did the CSR utilize Yonyx?', subtext: ''},
  ],
}

export const USER_LIST_USERS_VIEWING_OPTION = 'users'
export const USER_LIST_TEAMS_VIEWING_OPTION = 'teams'

export const USER_LIST_VIEWING_OPTIONS = [
  {value: USER_LIST_USERS_VIEWING_OPTION, label: 'Users'},
  {value: USER_LIST_TEAMS_VIEWING_OPTION, label: 'Teams'}
]

export const METRIC_COLOR_RANK1 = '#029154'
export const METRIC_COLOR_RANK2 = '#03C276'
export const METRIC_COLOR_RANK3 = '#69D49C'
export const METRIC_COLOR_RANK4 = '#FFC545'
export const METRIC_COLOR_RANK5 = '#FF913E'
export const METRIC_RANK_COLORS = [ METRIC_COLOR_RANK1, METRIC_COLOR_RANK2, METRIC_COLOR_RANK3, METRIC_COLOR_RANK4, METRIC_COLOR_RANK5 ]
export const METRIC_RANK_DEFAULT = 2
export const METRIC_RANK_BARRIERS = [90, 70, 30, 10, 0]
export const METRIC_RANK_SCORE_BARRIERS = [117, 109, 92, 84, 0]
export const METRIC_SCORE_MIN = 80
export const METRIC_SCORE_MAX = 120
export const METRIC_TYPE_CLOSED_DEALS = 'met_to_close'
export const METRIC_TYPE_MET_CLIENTS = 'new_to_met'
export const METRIC_TYPE_STATUS_UPDATED = 'referral_manager_update'
export const METRIC_TYPE_CLAIMED_LEADS = 'lead_alert_claim'
export const METRIC_TYPE_CONTACTING_REFERRALS = 'contacting_referrals'
export const METRIC_LOCK_LABELS = {
  [METRIC_TYPE_CLAIMED_LEADS]: 'Unlocks after receiving first lead alert',
  [METRIC_TYPE_STATUS_UPDATED]: 'Unlocks after winning first Opcity referral',
  [METRIC_TYPE_MET_CLIENTS]: 'Unlocks after meeting first client',
  [METRIC_TYPE_CLOSED_DEALS]: 'Unlocks after closing first deal',
  [METRIC_TYPE_CONTACTING_REFERRALS]: 'Unlocks after winning first Opcity referral',
}

export const CALL_TYPE = [
  {value:"agent-transfer",label:"Agent Transfer"},
  {value:"lender-transfer",label:"Lender Transfer"},
  {value:"lost-lender",label:"Lost Lender"},
  {value:"five-star-customer-satisfaction",label:"Five Star Customer Satisfaction"},
  {value:"four-star-customer-satisfaction",label:"Four Star Customer Satisfaction"},
  {value:"three-star-customer-satisfaction",label:"Three Star Customer Satisfaction"},
  {value:"short-term-release",label:"Short Term Release"},
  {value: "from-lead-page",label:"From Lead Page"}
]

export const CALL_GRADE_STATUS = [
  {value: -1, label: "All Grade Statuses"},
  {value:"open", label:"Open"},
  {value:"completed", label:"Completed"}
]

export const OFFICE_LOCATION = [
  {value:"austin", label:"Austin"},
  {value:"bogota", label:"Bogota"}
]

export const BROKER_AGREEMENT_SETUP_FEE = [
  {value: 0, label: '$0'},
]

export const MANAGEMENT_ROLES = [
  { value: 'supervisor', label: 'Supervisor', level: 0 },
  { value: 'manager', label: 'Manager', level: 1 },
  { value: 'senior-manager', label: 'Senior Manager', level: 2 },
  { value: 'director', label: 'Director', level: 3 },
]

export const INBOUND_EMAIL_REPROCESS_TIMES = {
  THIS_LEAD_ONLY: "this-lead-only",
  LAST_WEEK: "last-week",
  LAST_MONTH: "last-month"
}

export const INBOUND_EMAIL_REPROCESS_OPTIONS = {
  [INBOUND_EMAIL_REPROCESS_TIMES.THIS_LEAD_ONLY]: "This lead only",
  [INBOUND_EMAIL_REPROCESS_TIMES.LAST_WEEK]: "All from last week",
  [INBOUND_EMAIL_REPROCESS_TIMES.LAST_MONTH]: "All from last month"
}

export const BLA_STATUSES = {
  ENABLED: 'enabled',
  DELINQUENT: 'delinquent',
  SUSPENDED: 'suspended',
  CANCELED: 'canceled',
  PENDING: 'pending'
}

export const ACCOUNTING_SUPPORT_EMAIL = "accountingsupport@opcity.com"

export const LEAD_SOURCE_FILTERS = [
  { value: 'parent_source', label: 'Parent Source' },
  { value: 'source_type', label: 'Source Type' },
  { value: 'user_type', label: 'User Type' },
  { value: 'user_id', label: 'User' },
  { value: 'lead_status', label: 'Lead Status' },
  { value: 'inquiry_type', label: 'Inquiry Type'}
]

export const DOWN_FUNNEL_ASSIGNMENT_TYPE = {
  LIVE: 'live',
  WARM: 'warm',
  SMS: 'sms',
}

export const DOWN_FUNNEL_ASSIGNMENT_TYPE_LABELS = [
  { value: DOWN_FUNNEL_ASSIGNMENT_TYPE.LIVE, label: 'Live' },
  { value: DOWN_FUNNEL_ASSIGNMENT_TYPE.WARM, label: 'Email Only'},
  { value: DOWN_FUNNEL_ASSIGNMENT_TYPE.SMS, label: 'Text Connection'}
]

export const MAX_AGENT_CLOSE_AMOUNT = 1000000000

export const PERFORMANCE_DASHBOARD_DATE_FORMAT = 'MM/DD/YYYY h:mm A'

export const NON_CONFIRMED_QUALITY_PLAN_PREFIX = 'partner-paid'

export const PROPERTY_TOUR_SCHEDULE_STATUS = {
  SCHEDULED: 'scheduled',
  COMPLETED: 'completed',
  SUGGESTED: 'suggested',
  UNKNOWN: 'unknown',
  CANCELLED: 'cancelled',
  REQUESTED: 'requested'
}

export const CLOSING_DOCUMENT_FILTER_DOCUMENT_TYPE_LABELS = [
  {label: "Auto-Linked with Transactions", value: "autolinked"},
  {label: "Linked with Transactions", value: "linked"},
  {label: "Not Linked with Transactions", value: "unlinked"},
]

export const CLOSING_DOCUMENT_FILTER_TRANSACTION_TYPE_LABELS = [
  {label: "Projected Closes", value: "projected-closes"},
  {label: "Pending Closed", value: "pending-closed"},
  {label: "Confirmed Closed", value: "confirmed-closed"},
  {label: "Archived", value: "archived"},
]

export const OPCITY_TIMEZONE = 'America/Chicago'

export const HOMEGO_PHONE = '(469) 251-1193'

export const MATCH_FEEDBACK_TYPE_DESCRIPTIONS = {
  'agent-already-invited': 'Agent has already been invited',
  'agent-no-office-relationship': 'Agent is not connected with this brokerage ',
  'agent-moved-or-terminated': 'Agent has moved or been terminated from this brokerage ',
  'agent-incorrect-data': 'Agent information is incorrect',
  'agent-duplicate-record': 'This is a duplicate',
}

const MATCH_FEEDBACK_DESCRIPTION_ORDERING = [
  'agent-already-invited',
  'agent-moved-or-terminated',
  'agent-no-office-relationship',
  'agent-incorrect-data',
  'agent-duplicate-record'
]

export const MATCH_FEEDBACK_OPTIONS = _.map(
  MATCH_FEEDBACK_DESCRIPTION_ORDERING,
  item => ({
    value: item,
    label: MATCH_FEEDBACK_TYPE_DESCRIPTIONS[item]
  })
)

export const AGENT_SUCCESS_TOUCH_STAGES = {
  FIRST_DAY: '1',
  FIRST_WEEK: '2.1',
  AFTER_FIRST_WEEK: '2.2',
  FIRST_REFERRAL: '3',
  FIRST_CONTRACT: '4',
}

export const LEAD_AVAILABILITY_DATE_TIME_WINDOW_LABELS = [
  {label: 'Weekend', value: 'weekends'},
  {label: 'Weekday', value: 'weekdays'},
  {label: 'By Appointment', value: 'by-appointment'},
  {label: 'Anytime', value: 'anytime'},
  {label: 'Mornings', value: 'mornings'},
  {label: 'Afternoons', value: 'afternoons'},
  {label: 'Evenings', value: 'evenings'},
  {label: 'As Soon As Possible', value: 'asap'},
]

export const AGENT_SUCCESS_GOALS = {
  STAGE_1_PHONE_NUMBER: 'Agent Success - Stage 1 - Phone Number',
  STAGE_1_VIDEO: 'Agent Success - Stage 1 - Video',
  STAGE_2_1_PHONE_NUMBER: 'Agent Success - Stage 2.1 - Phone Number',
  STAGE_2_1_SUPPORT_ARTICLE: 'Agent Success - Stage 2.1 - Support Article',
  STAGE_2_2_PHONE_NUMBER: 'Agent Success - Stage 2.2 - Phone Number',
  STAGE_2_2_VIDEO: 'Agent Success - Stage 2.2 - Video',
  STAGE_2_2_SUPPORT_ARTICLE: 'Agent Success - Stage 2.2 - Support Article',
  STAGE_3_PHONE_NUMBER: 'Agent Success - Stage 3 - Phone Number',
  STAGE_3_SUPPORT_ARTICLE: 'Agent Success - Stage 3 - Support Article',
  STAGE_4_PHONE_NUMBER: 'Agent Success - Stage 4 - Phone Number',
  STAGE_4_SUPPORT_ARTICLE: 'Agent Success - Stage 4 - Support Article',
}

export function toLaunchDarklyAgentSuccessGoalName({ phoneNumber, stage, url, videoUrl }) {
  if (stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_DAY) {
    if (phoneNumber) {
      return AGENT_SUCCESS_GOALS.STAGE_1_PHONE_NUMBER
    } else if (videoUrl) {
      return AGENT_SUCCESS_GOALS.STAGE_1_VIDEO
    }
  } else if (stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_WEEK) {
    if (phoneNumber) {
      return AGENT_SUCCESS_GOALS.STAGE_2_1_PHONE_NUMBER
    } else if (url) {
      return AGENT_SUCCESS_GOALS.STAGE_2_1_SUPPORT_ARTICLE
    }
  } else if (stage === AGENT_SUCCESS_TOUCH_STAGES.AFTER_FIRST_WEEK) {
    if (phoneNumber) {
      return AGENT_SUCCESS_GOALS.STAGE_2_2_PHONE_NUMBER
    } else if (url) {
      return AGENT_SUCCESS_GOALS.STAGE_2_2_SUPPORT_ARTICLE
    } else if (videoUrl) {
      return AGENT_SUCCESS_GOALS.STAGE_2_2_VIDEO
    }
  } else if (stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_REFERRAL) {
    if (phoneNumber) {
      return AGENT_SUCCESS_GOALS.STAGE_3_PHONE_NUMBER
    } else if (url) {
      return AGENT_SUCCESS_GOALS.STAGE_3_SUPPORT_ARTICLE
    }
  } else if (stage === AGENT_SUCCESS_TOUCH_STAGES.FIRST_CONTRACT) {
    if (phoneNumber) {
      return AGENT_SUCCESS_GOALS.STAGE_4_PHONE_NUMBER
    } else if (url) {
      return AGENT_SUCCESS_GOALS.STAGE_4_SUPPORT_ARTICLE
    }
  }
}

export const POOLED_BROKER_SUCCESS_SUPPORT_LABEL = {label: 'support.realtor.com', value:'https://support.realtor.com/s/contactsupport'}
export const POOLED_BROKER_SUCCESS_SUPPORT_EMAIL = 'brokersupport@realtor.com'

export const POOLED_BROKER_SUCCESS_REP_PHONE = '(844) 225-0259'

export const LEAD_SOURCE_BANNER_TYPE_VALUES = [
  {value: 'seller', label: 'Seller:', className: 'LeadSourceBanner--seller'},
  {value: 'motivated_seller', label: 'Motivated Seller:', className: 'LeadSourceBanner--seller'},
  {value: 'mortgage', label: 'Financing:', className: 'LeadSourceBanner--mortgage'},
  {value: 'broker', label: 'Broker:', className: 'LeadSourceBanner--broker'},
  {value: 'agent_search', label: 'Agent Search:', className: 'LeadSourceBanner--agent_search'},
  {value: 'partner', label: 'Partner:', className: 'LeadSourceBanner--partner'},
  {value: 'prequalified_lead', label: 'Pre-Qualified Lead:', className: 'LeadSourceBanner--prequalified_lead'},
  {value: 'leasing', label: 'Leasing:', className: 'LeadSourceBanner--leasing'},
]

export const TRANSITION_BROKER_DISPATCH_PHRASE = 'I first wanted to let you know, that this lead is owned by your brokerage...'

export const ROLE_RULES = {
  SUPER: {
    viewSupportTab: ({user}) => {
      // bad example, but pattern for "dynamic" permissions
      // given a role and a permission to request, can programmatically check values on user

      // this block is to satisfy stickler, can't have unused variables
      if (user) {
        return true
      }
      return true
    }
  }
}

export const VETERANS_UNITED_ELIGIBLE_STATES = [
  'MO', 'KS', 'OK', 'PA', 'TX', 'VA', 'WI'
]

export const AGENT_MARKET_COVERAGE_TYPES = [
  {value: 'market-vip', label: 'Market VIP', badgeType: 'market-vip'},
  {value: 'transition', label: 'Market VIP', badgeType: 'transition'},
  {value: 'pure-market', label: 'Pure Market', badgeType: null},
  {value: 'rewards', label: 'Client Rewards', badgeType: 'rewards'},
  {value: 'platinum', label: 'Platinum', badgeType: 'platinum'},
  {value: 'promotional', label: 'Promotional', badgeType: 'promotional'},
  {value: 'google-rewards', label: 'Smart Home Rewards', badgeType: 'google-rewards'},
  {value: 'highrises', label: 'Highrises', badgeType: 'highrises'},
]

export const RELEASE_SPEEDBUMP_CUTOFF_DAYS = 28

export const COVID_19_RESOURCES_URL = 'https://hub.realtor.com/covid-19-resources'

export const DYNAMIC_PRICING_CATEGORY = {
  STANDARD: 'standard',
  MARKET_VIP: 'market-vip',
  TRANSITION: 'transition',
  HIGHRISES: 'highrises',
}

export const DYNAMIC_PRICING_CATEGORY_LABEL = {
  [DYNAMIC_PRICING_CATEGORY.TRANSITION]: 'Market VIP',
  [DYNAMIC_PRICING_CATEGORY.HIGHRISES]: 'Highrises'
}

export const CALLBACK_DELAY_MINUTES = {
  LENDER: 30,
  CREDIT_REPAIR: 30,
}

export const L2C_MATCH_STATUS = {
  MATCH: 'match',
  NO_MATCH: 'no_match',
  FUZZY_MATCH: 'fuzzy_match'
}

export const SAVED_CLAIM_ACTIONS = {
  OPENED: 'saved-claim-opened',
  ACTED_UPON: 'saved-claim-acted-upon',
  DISMISSED: 'saved-claim-dismissed',
}

export const QUESTION_TYPE = {
  TITLE_WILL_YOU_SELECT: 'title_will_you_select',
  TITLE_DO_YOU_KNOW_PROVIDER: 'title_do_you_know_provider',
  TITLE_WHO_IS_PROVIDER: 'title_who_is_provider',
  TITLE_PLACED_ORDER: 'title_placed_order',
  TITLE_PLACE_ORDER_NOW: 'title_place_order_now',
}

export const ANSWER_TYPE = {
  YES_NO: 'yes_no',
  TITLE_SELECTION: 'title_selection',
}

export const TITLE_WILL_YOU_SELECT_CHOICES = ({type, noButtonText}) =>
  [
    {value: "yes", label: "Yes"},
    {value: "no", label: `No, ${type}er ${noButtonText}`},
    {value: "not-sure", label: "Not sure"},
  ]

export const TITLE_DO_YOU_KNOW_PROVIDER_CHOICES = [
  {value:"yes", label:"Yes"},
  {value:"no", label:"No, not yet"},
]

export const TITLE_PLACED_ORDER_CHOICES = [
  {value:"yes", label:"Yes"},
  {value:"no", label:"No"},
]

export const QUALIA_QUESTIONS = {
  [AGENT_STATUS_OFFER]: {
    [QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: {
      'subtitle': 'TITLE DETAILS',
      'question': 'Will you and your client select title?',
      'no-button-text': 'will select',
      'not-sure-button': true,
    },
    [QUESTION_TYPE.TITLE_DO_YOU_KNOW_PROVIDER]: {
    },
    [QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: {
      'question': null,
      'is-required': false,
    },
  },
  [AGENT_STATUS_CONTRACT]: {
    [QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: {
      'subtitle': 'TITLE DETAILS',
      'question': 'Are you and your client selecting title?',
      'no-button-text': 'is selecting',
      'not-sure-button': false
    },
    [QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: {
      'question': 'Who is your title provider?',
      'is-required': false,
    },
    [QUESTION_TYPE.TITLE_PLACED_ORDER]: {
    },
    [QUESTION_TYPE.TITLE_PLACE_ORDER_NOW]: {
    }
  },
  [AGENT_STATUS_CLOSED]: {
    [QUESTION_TYPE.TITLE_WILL_YOU_SELECT]: {
      'question': 'Were you and your client responsible for selecting title?',
      'no-button-text': 'selected',
      'not-sure-button': false
    },
    [QUESTION_TYPE.TITLE_WHO_IS_PROVIDER]: {
      'question': 'Who was the title provider on this transaction?',
      'is-required': true,
    },
  }
}

export const DIGITAL_LOAN_TYPES = {
  fha: {
    description: "A FHA loan is a mortgage that is insured by the Federal Housing Administration (FHA) and issued by an FHA-approved lender. These loans typically allow for a lower down payment.",
    label: "FHA",
  },
  va: {
    description: "A VA loan is a mortgage loan for qualified veterans, service members and eligible surviving spouses that is backed by the U.S. Department of Veterans Affairs.",
    label: "VA",
  },
}

export const DIGITAL_LENDER_PROVIDERS = {
  BETTER: 'BETTER',
  PADDIO: 'PADDIO',
  ROCKET_MORTGAGE: 'ROCKET_MORTGAGE',
}
